
var Shopify = Shopify || {};

var bodyScrollLockOptions = {
    reserveScrollBarGap: false,
};

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

/* Fixes iphone bug with back button, this prevents showing opened drawers like menu and search when going back to home page!*/

window.addEventListener('pagehide', function () {
    document.querySelector('.SearchWrapper').setAttribute("aria-hidden", true);
    document.querySelector('#sidebarDrawer').setAttribute("aria-expanded", false);
    document.querySelector('#cart').setAttribute("aria-expanded", false);
})

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
    /**
     * Maintain a map of listener
     * lists, keyed by event name.
     *
     * @type Object
     */
    this.listenerMap = [{}, {}];
    if (root) {
        this.root(root);
    }

    /** @type function() */
    this.handle = Delegate.prototype.handle.bind(this);

    // Cache of event listeners removed during an event cycle
    this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;

    // Remove master event listeners
    if (this.rootElement) {
        for (eventType in listenerMap[1]) {
            if (listenerMap[1].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, true);
            }
        }
        for (eventType in listenerMap[0]) {
            if (listenerMap[0].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, false);
            }
        }
    }

    // If no root or root is not
    // a dom node, then remove internal
    // root reference and exit here
    if (!root || !root.addEventListener) {
        if (this.rootElement) {
            delete this.rootElement;
        }
        return this;
    }

    /**
     * The root node at which
     * listeners are attached.
     *
     * @type Node
     */
    this.rootElement = root;

    // Set up master event listeners
    for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, true);
        }
    }
    for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, false);
        }
    }

    return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
    return (
        ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
            eventType
        ) !== -1
    );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;

    if (!eventType) {
        throw new TypeError("Invalid event type: " + eventType);
    }

    // handler can be passed as
    // the second or third argument
    if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
    }

    // Fallback to sensible defaults
    // if useCapture not set
    if (useCapture === undefined) {
        useCapture = this.captureForType(eventType);
    }

    if (typeof handler !== "function") {
        throw new TypeError("Handler must be a type of Function");
    }

    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];

    // Add master handler for type if not created yet
    if (!listenerMap[eventType]) {
        if (root) {
            root.addEventListener(eventType, this.handle, useCapture);
        }
        listenerMap[eventType] = [];
    }

    if (!selector) {
        matcherParam = null;

        // COMPLEX - matchesRoot needs to have access to
        // this.rootElement, so bind the function to this.
        matcher = matchesRoot.bind(this);

        // Compile a matcher for the given selector
    } else if (/^[a-z]+$/i.test(selector)) {
        matcherParam = selector;
        matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
        matcherParam = selector.slice(1);
        matcher = matchesId;
    } else {
        matcherParam = selector;
        matcher = Element.prototype.matches;
    }

    // Add to the list of listeners
    listenerMap[eventType].push({
        selector: selector,
        handler: handler,
        matcher: matcher,
        matcherParam: matcherParam,
    });

    return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;

    // Handler can be passed as
    // the second or third argument
    if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
    }

    // If useCapture not set, remove
    // all event listeners
    if (useCapture === undefined) {
        this.off(eventType, selector, handler, true);
        this.off(eventType, selector, handler, false);
        return this;
    }

    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
        for (singleEventType in listenerMap) {
            if (listenerMap.hasOwnProperty(singleEventType)) {
                this.off(singleEventType, selector, handler);
            }
        }

        return this;
    }

    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
        return this;
    }

    // Remove only parameter matches
    // if specified
    for (i = listenerList.length - 1; i >= 0; i--) {
        listener = listenerList[i];

        if (
            (!selector || selector === listener.selector) &&
            (!handler || handler === listener.handler)
        ) {
            this._removedListeners.push(listener);
            listenerList.splice(i, 1);
        }
    }

    // All listeners removed
    if (!listenerList.length) {
        delete listenerMap[eventType];

        // Remove the main handler
        if (this.rootElement) {
            this.rootElement.removeEventListener(eventType, this.handle, useCapture);
        }
    }

    return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";

    if (event[eventIgnore] === true) {
        return;
    }

    target = event.target;

    // Hardcode value of Node.TEXT_NODE
    // as not defined in IE8
    if (target.nodeType === 3) {
        target = target.parentNode;
    }

    // Handle SVG <use> elements in IE
    if (target.correspondingUseElement) {
        target = target.correspondingUseElement;
    }

    root = this.rootElement;

    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

    // eslint-disable-next-line default-case
    switch (phase) {
        case 1: //Event.CAPTURING_PHASE:
            listenerList = this.listenerMap[1][type];
            break;
        case 2: //Event.AT_TARGET:
            if (this.listenerMap[0] && this.listenerMap[0][type]) {
                listenerList = listenerList.concat(this.listenerMap[0][type]);
            }
            if (this.listenerMap[1] && this.listenerMap[1][type]) {
                listenerList = listenerList.concat(this.listenerMap[1][type]);
            }
            break;
        case 3: //Event.BUBBLING_PHASE:
            listenerList = this.listenerMap[0][type];
            break;
    }

    let toFire = [];

    // Need to continuously check
    // that the specific list is
    // still populated in case one
    // of the callbacks actually
    // causes the list to be destroyed.
    l = listenerList.length;
    while (target && l) {
        for (i = 0; i < l; i++) {
            listener = listenerList[i];

            // Bail from this loop if
            // the length changed and
            // no more listeners are
            // defined between i and l.
            if (!listener) {
                break;
            }

            if (
                target.tagName &&
                ["button", "input", "select", "textarea"].indexOf(
                    target.tagName.toLowerCase()
                ) > -1 &&
                target.hasAttribute("disabled")
            ) {
                // Remove things that have previously fired
                toFire = [];
            }
            // Check for match and fire
            // the event if there's one
            //
            // TODO:MCG:20120117: Need a way
            // to check if event#stopImmediatePropagation
            // was called. If so, break both loops.
            else if (listener.matcher.call(target, listener.matcherParam, target)) {
                toFire.push([event, target, listener]);
            }
        }

        // TODO:MCG:20120117: Need a way to
        // check if event#stopPropagation
        // was called. If so, break looping
        // through the DOM. Stop if the
        // delegation root has been reached
        if (target === root) {
            break;
        }

        l = listenerList.length;

        // Fall back to parentNode since SVG children have no parentElement in IE
        target = target.parentElement || target.parentNode;

        // Do not traverse up to document root when using parentNode, though
        if (target instanceof HTMLDocument) {
            break;
        }
    }

    let ret;

    for (i = 0; i < toFire.length; i++) {
        // Has it been removed during while the event function was fired
        if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
            continue;
        }
        returned = this.fire.apply(this, toFire[i]);

        // Stop propagation to subsequent
        // callbacks if the callback returned
        // false
        if (returned === false) {
            toFire[i][0][eventIgnore] = true;
            toFire[i][0].preventDefault();
            ret = false;
            break;
        }
    }

    return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} _selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(_selector, element) {
    if (this.rootElement === window) {
        return (
            // Match the outer document (dispatched from document)
            element === document ||
            // The <html> element (dispatched from document.body or document.documentElement)
            element === document.documentElement ||
            // Or the window itself (dispatched from window)
            element === window
        );
    }
    return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
    return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
    this.off();
    this.root();
};

class Utility {
    /**
    * Updates the element's classes, aria attributes, and data attributes based on the provided update object.
    * @param {HTMLElement} element - The element to update.
    * @param {Object} updates - An object where keys are class names or attribute names and values indicate the desired state (true/false for classes, values for attributes).
    */
    static updateElement(element, updates) {
     Object.keys(updates).forEach(key => {
       if (key.startsWith('aria-')) {
         element.setAttribute(key, updates[key]);
       } else if (key.startsWith('data-')) {
         element.dataset[key.slice(5)] = updates[key];
       } else {
         if (updates[key]) {
           element.classList.add(key);
         } else {
           element.classList.remove(key);
         }
       }
     });
   }
 
   /**
    * Disables body scroll for the specified element.
    * @param {HTMLElement} element - The element containing a child with the data-scrollable attribute, or the element itself.
    */
   static bodyScrollLockDisable(element) {
     // Check if the element itself has the data-scrollable attribute
     const scrollableElement = element.hasAttribute('data-scrollable') 
       ? element 
       : element.querySelector('[data-scrollable]');
     
     if (scrollableElement) {
       bodyScrollLock.disableBodyScroll(scrollableElement, bodyScrollLockOptions);
       console.log("body scroll disable", scrollableElement);
     } else {
       console.error("No element with data-scrollable attribute found.");
     }
   }
 
   /**
    * Enables body scroll for the specified element.
    * @param {HTMLElement} element - The element containing a child with the data-scrollable attribute, or the element itself.
    */
   static bodyScrollLockEnable(element) {
     // Check if the element itself has the data-scrollable attribute
     const scrollableElement = element.hasAttribute('data-scrollable') 
       ? element 
       : element.querySelector('[data-scrollable]');
     
     if (scrollableElement) {
       bodyScrollLock.enableBodyScroll(scrollableElement, bodyScrollLockOptions);
     } else {
       console.error("No element with data-scrollable attribute found.");
     }
   }

   /**
    * Clears all body scroll locks.
    */
   static bodyScrollLockClear() {
        bodyScrollLock.clearAllBodyScrollLocks();
    }
 
   /**
    * Returns all focusable elements within the specified container.
    * @param {HTMLElement} container - The container to search for focusable elements.
    * @returns {HTMLElement[]} - Array of focusable elements.
    */
   static getFocusableElements(container) {
     return Array.from(
       container.querySelectorAll(
         "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
       )
     );
   }
 
   /**
    * Traps focus within the specified container.
    * @param {HTMLElement} container - The container to trap focus within.
    * @param {HTMLElement} [elementToFocus=container] - The element to focus initially.
    */
   static trapFocus(container, elementToFocus = container) {
     const elements = Utility.getFocusableElements(container);
     const first = elements[0];
     const last = elements[elements.length - 1];
 
     // Remove existing focus trap to avoid duplicate handlers
     Utility.removeTrapFocus();
 
     // Define the focus trap handlers
     const trapFocusHandlers = {
       /**
        * Handles focusin event to add keydown listener if necessary.
        * @param {FocusEvent} event - The focusin event.
        */
       focusin(event) {
         if (
           event.target !== container &&
           event.target !== last &&
           event.target !== first
         )
           return;
 
         document.addEventListener("keydown", trapFocusHandlers.keydown);
       },
 
       /**
        * Handles focusout event to remove keydown listener.
        */
       focusout() {
         document.removeEventListener("keydown", trapFocusHandlers.keydown);
       },
 
       /**
        * Handles keydown event to trap Tab key navigation within the container.
        * @param {KeyboardEvent} event - The keydown event.
        */
       keydown(event) {
         if (event.key !== "Tab") return; // If not TAB key
         // On the last focusable element and tab forward, focus the first element.
         if (event.target === last && !event.shiftKey) {
           event.preventDefault();
           first.focus();
         }
 
         // On the first focusable element and tab backward, focus the last element.
         if (
           (event.target === container || event.target === first) &&
           event.shiftKey
         ) {
           event.preventDefault();
           last.focus();
         }
       }
     };
 
     // Add focusin and focusout listeners
     document.addEventListener("focusout", trapFocusHandlers.focusout);
     document.addEventListener("focusin", trapFocusHandlers.focusin);
 
     // Focus the first focusable element or the specified elementToFocus
     if (first) {
       first.focus();
     } else {
       elementToFocus.focus();
     }
 
     // Store handlers to enable proper removal
     Utility.trapFocusHandlers = trapFocusHandlers;
   }
 
   /**
    * Removes the focus trap and optionally focuses a specified element.
    * @param {HTMLElement} [elementToFocus=null] - The element to focus after removing the focus trap.
    */
   static removeTrapFocus(elementToFocus = null) {
     if (Utility.trapFocusHandlers) {
       document.removeEventListener("focusin", Utility.trapFocusHandlers.focusin);
       document.removeEventListener("focusout", Utility.trapFocusHandlers.focusout);
       document.removeEventListener("keydown", Utility.trapFocusHandlers.keydown);
 
       if (elementToFocus) elementToFocus.focus();
     }
   }
 
   static pageOverlayOpen(element){
      // Toggle visibility classes to show the drawer
      Utility.updateElement(element, {
       'u-hidden': false,
       'u-visible': true
     });
       // Use requestAnimationFrame to ensure the attribute change happens in the next frame
       requestAnimationFrame(() => {
         element.setAttribute('aria-hidden', 'false');
       });
 
   
   }
 
   static pageOverlayClose(element){
     element.setAttribute('aria-hidden', 'true');
    // Add an event listener for the transition end
 
    element.addEventListener('transitionend', function handleTransitionEnd(event) {
     if (event.propertyName === 'opacity') {
       // Ensure the event is fired for opacity transition
       Utility.updateElement(element, {
         'u-visible': false,
         'u-hidden': true
       });
 
       // Remove the event listener after it's done to avoid multiple calls
       element.removeEventListener('transitionend', handleTransitionEnd);
     }
   });
   }
 }

class Popup {
    constructor(element) {
        this.element = element;
        this.delegateElement = new Delegate(this.element);
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this.bindEvents();
    }
    bindEvents() {
        this.delegateElement.on(
            "click",
            '[data-action="open-modal"]',
            this.openModal.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="close-modal"]',
            this.closeModal.bind(this)
        );
        document.addEventListener("posted_successfully", this.openModalSpecial.bind(this));

        this.onClickOutsideListener = this.closeModal.bind(this);

    }

    openModal() {
        event.preventDefault();
        event.stopPropagation();
        this.pageOverlayElement.classList.add("is-visible");
        this.activeModal = document.getElementById(
            event.target.getAttribute("aria-controls")
        );
        this.activeModal.setAttribute("aria-hidden", "false");
        this.activeModal.style.display = "block";
        this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);

        setTimeout(() => { trapFocus(this.activeModal); }, 100);
        Utility.bodyScrollLockDisable(this.element);
    }
    
    openModalSpecial() {
        event.preventDefault();
        event.stopPropagation();
        this.pageOverlayElement.classList.add("is-visible");
        this.activeModal = document.getElementById(event.detail.id);
        this.activeModal.setAttribute("aria-hidden", "false");
        this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);
        Utility.bodyScrollLockDisable(this.element);
        trapFocus(this.activeModal);
    }

    closeModal() {
        this.activeModal = document.body.querySelector('.Popup[aria-hidden="false"]');
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
        this.activeModal.setAttribute("aria-hidden", "true");

        Utility.bodyScrollLockClear();
        this.activeModal.removeAttribute("style");

    }


}

class RevolutionImageZoom {
    constructor(element, slideshow) {
      this.element = element;
      this.slideshow = slideshow;
      this.delegateElement = new Delegate(this.element);
      this.delegateRoot = new Delegate(document.body);
  
      this.syncHeight();
      this.bindEvents();
    }
  
    syncHeight() {
      document.documentElement.style.setProperty(
        "--window-inner-height",
        `${window.innerHeight}px`
      );
    }
  
    bindEvents() {
      window.addEventListener("resize", this.syncHeight());
      this.delegateElement.on(
        "click",
        '[data-action="open-product-zoom"]',
        this.initPhotoSwipe.bind(this)
      );
      this.delegateElement.on(
        "click",
        ".ProductSliderCell--Zoom",
        this.initPhotoSwipeFromImageClick.bind(this)
      );
      this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--close",
        this.photoswiperClose.bind(this)
      );
    }
    photoswiperClose() {
      this.photoSwipeInstance.close;
      if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
        document.documentElement.classList.remove("pswp-open-in-ios");
      }
    }
  
    initPhotoSwipe() {
      var images = [],
      index_currentSlide = 0;
      if (this.slideshow) {
        this.slideshow.swiperElement.slides.forEach(function (item) {
          if (item.classList.contains("ProductSliderCell--Zoom")) {
            if (item.querySelector("img")) {
              images.push(item.querySelector("img"));
            }
          }
        });
        var index_currentSlide = this.slideshow.swiperElement.realIndex;
        this.slideshow.swiperElement.slides[index_currentSlide]
          .querySelector(".ProductSlider--Element")
          .getAttribute("data-image-position");
      } else {
        images.push(document.querySelector(".ProductSlider--Image"));
      }
  
      this.createPhotoSwipeInstance(
        this.createPhotoSwipeItemsFromImages(images),
        parseInt(index_currentSlide)
      );
    }
  
    initPhotoSwipeFromImageClick(event, target) {
      // Check if the current breakpoint is "pocket". If it is, return without doing anything.
      if (new Responsive().matchesBreakpoint("pocket")) {
        return;
      }
  
      // Create an array of images from the siblings of the target element.
      const images = [];
      const siblings = Array.from(target.parentElement.children);
  
      siblings.forEach((item) => {
        if (
          item.classList.contains("ProductSliderCell--Zoom") &&
          item.querySelector("img")
        ) {
          images.push(item.querySelector("img"));
        }
      });
  
      // Get the image position from the target element's data attribute.
      const imagePosition = parseInt(
        target
          .querySelector(".ProductSlider--Element")
          .getAttribute("data-image-position")
      );
  
      // Create the PhotoSwipe instance using the images and image position.
      this.createPhotoSwipeInstance(
        this.createPhotoSwipeItemsFromImages(images),
        imagePosition
      );
    }
  
    createPhotoSwipeItemsFromImages(images) {
      return images.map(function (image) {
        var maxWidth = parseInt(image.getAttribute("data-max-width")),
          maxHeight = parseInt(image.getAttribute("data-max-height")),
          maxDimension = new Responsive().matchesBreakpoint("phone")
            ? 1200
            : 2200,
          reduceFactor = 1.0;
  
        if (maxWidth >= maxHeight) {
          reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
        } else {
          reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
        }
        var requestedWidth = Math.floor(maxWidth / reduceFactor);
        var requestedHeight = Math.floor(maxHeight / reduceFactor);
        return {
          msrc: image.currentSrc || image.src,
          w: requestedWidth,
          h: requestedHeight,
          initialZoomLevel: 0.65,
          src: image.dataset.originalSrc,
        };
      });
    }
  
    createPhotoSwipeInstance(items, selectedImageIndex) {
    
      var _this = this;
      var photoswipeContainer = document.querySelector(".pswp");
      this.photoSwipeInstance = new PhotoSwipe(
        photoswipeContainer,
        false,
        items,
        {
          index: selectedImageIndex,
          showHideOpacity: true,
          showAnimationDuration: 500,
          maxSpreadZoom: 10,
          loop: false,
          history: false,
          closeOnVerticalDrag: true,
          allowPanToNext: false,
          pinchToClose: false,
          errorMsg: '<p class="pswp__error-msg"></p>',
          scaleMode: "orig",
          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
            if (isMouseClick) {
              return 1.35;
            } else {
              return item.initialZoomLevel < 0.7 ? 1.5 : 4;
            }
          },
          getThumbBoundsFn: function getThumbBoundsFn(index) {
            var allThumbnail = document.querySelectorAll(
                ".Product--Wrapper .ProductSliderCell--Zoom img"
              ),
              thumbnail = allThumbnail[index],
              pageYScroll =
                window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        }
      );
  
      this.photoSwipeInstance.listen(
        "beforeChange",
        this.onslideChanged.bind(this)
      );
      this.photoSwipeInstance.listen(
        "destroy",
        this.destroyPhotoSwipe.bind(this)
      );
      this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
      this.photoSwipeInstance.listen(
        "initialZoomIn",
        this.onInitialZoomIn.bind(this)
      );
      this.photoSwipeInstance.listen(
        "initialZoomOut",
        this.onInitialZoomOut.bind(this)
      );
  
      this.delegateRoot.on(
        "pswpTap",
        ".pswp__scroll-wrap",
        this.onSingleTap.bind(this)
      );
      this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--close",
        this.photoSwipeInstance.close
      );
      this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--prev",
        this.photoSwipeInstance.prev
      );
      this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--next",
        this.photoSwipeInstance.next
      );
      this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
      if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
        document.documentElement.classList.add("pswp-open-in-ios");
      }
      this.photoSwipeInstance.init();
    }
  
    onslideChanged() {
      if (this.photoSwipeInstance.getCurrentIndex() === 0) {
        this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--prev")
          .setAttribute("disabled", "disabled");
      } else {
        this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--prev")
          .removeAttribute("disabled");
      }
  
      if (
        this.photoSwipeInstance.getCurrentIndex() + 1 ===
        this.photoSwipeInstance.options.getNumItemsFn()
      ) {
        this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--next")
          .setAttribute("disabled", "disabled");
      } else {
        this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--next")
          .removeAttribute("disabled");
      }
    }
  
    onSingleTap(event) {
      if (!event.detail || event.detail.pointerType === "mouse") {
        if (event.target.classList.contains("pswp__img")) {
          this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
        }
      } else {
        if (event.target.classList.contains("pswp__button")) {
          return;
        }
  
        event.target
          .closest(".pswp")
          .querySelector(".pswp__ui")
          .classList.toggle("pswp__ui--hidden");
      }
    }
  
    onDoubleTap(point) {
      var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;
  
      if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
        this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
      } else {
        this.photoSwipeInstance.zoomTo(
          initialZoomLevel < 0.7 ? 1 : 1.33,
          point,
          333
        );
      }
    }
  
    onInitialZoomIn() {
      document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
    }
    onInitialZoomOut() {
      document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
    }
    destroyPhotoSwipe() {
      this.delegateRoot.off("pswpTap");
      this.photoSwipeInstance = null;
    }
  }

class RevolutionSelectbox {
    static elementList = [];

    constructor(element, popover, additionalOverlay) {
        this.element = element;
        this.elementList = RevolutionSelectbox.elementList;

        if (this.elementList.includes(this.element)) return;
        this.elementList.push(this.element);
    
        this.popover = popover;
        this.changeOverlay = additionalOverlay;
        this.domDelegate = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);
        this.dropdown = this.element.querySelector('.RevolutionDropdown');
        this.mainDropdown = this.element.querySelector(".RevolutionDropdown--Content");
        this.mainDropdownContent = this.element.querySelector(".RevolutionDropdown--InnerContent");
        this.mainButton = this.element.querySelector(".RevolutionDropdown--Button");
        this.connectedSelect = this.element.getAttribute('data-select');
        this.selectbox = this.element.querySelector('[name=' + this.connectedSelect + ']');
        if (this.selectbox == null) {
            this.selectbox = this.element.querySelector('[name2=' + this.connectedSelect + ']');
        }
        if (this.popover == true) {
            this.mainDropdown.classList.add('PopoverContent');
            if (this.changeOverlay) {
                this.pageOverlayElement = document.querySelector(".localizationOverlay");
            } else {
                this.pageOverlayElement = document.querySelector(".pageOverlay");
            }

        }
        this.bindEvents();
        this.initSelectbox();
    }

    bindEvents() {
        this.onClickOutsideListener = this.onClickOutside.bind(this);
        this.domDelegate.on(
            "click",
            "[data-action=toggle-selectbox]",
            this.toggleDropdown.bind(this)
        );

        this.domDelegate.on(
            "click",
            "[data-action=close-selectbox]",
            this.closeDropdown.bind(this)
        );

        this.domDelegate.on(
            "click",
            "[data-action=selectbox-submit]",
            this.selectboxSubmit.bind(this)
        );
        this.domDelegate.on(
            "keypress",
            "[data-action=selectbox-submit]",
            this.selectboxSubmit.bind(this)
        );

        this.domDelegate.on(
            "click",
            "[data-action=selectbox-change]",
            this.selectboxChange.bind(this)
        );

        this.domDelegate.on(
            "click",
            "[data-action=special-close]",
            this.toggleDropdown.bind(this)
        );
        this.domDelegate.on('click', 'body', this.onClickOutside.bind(this));

    }

      selectboxChange() {
    var value = event.target.getAttribute('data-value');
    var selectboxID = event.target.getAttribute('data-selectboxid');
    var innerContent = event.target.innerHTML;

    event.target.setAttribute('selected','selected');
    var siblings = new DomHelper().getSiblings(event.target);

    siblings.forEach(function (item) {
        item.removeAttribute('selected');
    });
    var selEl = this.element.querySelector('#' + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event('change'));
    } else {
      selEl.value = value;
      if ("createEvent" in document) {
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        selEl.dispatchEvent(evt);
    }
    else { selEl.fireEvent("onchange");}

    }
    this.mainButton.querySelector('.RevolutionDropdown--Title').innerHTML = innerContent;
    this.closeDropdown(event, this.element);
  }
  selectboxChange() {
    var value = event.target.getAttribute('data-value');
    var selectboxID = event.target.getAttribute('data-selectboxid');
    var innerContent = event.target.innerHTML;

    event.target.setAttribute('selected','selected');
    var siblings = new DomHelper().getSiblings(event.target);

    siblings.forEach(function (item) {
        item.removeAttribute('selected');
    });
    var selEl = this.element.querySelector('#' + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event('change'));
    } else {
      selEl.value = value;
      if ("createEvent" in document) {
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        selEl.dispatchEvent(evt);
    }
    else { selEl.fireEvent("onchange");}

    }
    this.mainButton.querySelector('.RevolutionDropdown--Title').innerHTML = innerContent;
    this.closeDropdown(event, this.element);
  }

    

    onClickOutside(event) {
        const withinBoundaries = event.composedPath().includes(this.element);
        if (!withinBoundaries || event.target.classList.contains('FiltersDesktopWrapper')) {
            this.closeDropdown(event, this.element);
        }
    }

    selectboxSubmit() {

        if (event.key != "Enter" && event.key !== undefined) {
            return;
        }
        var value = event.target.getAttribute('data-value');
        var dataName = event.target.getAttribute('data-name');
        this.selectbox.value = value;
        this.closeDropdown(event, this.element);
        this.mainButton.querySelector('.RevolutionDropdown--Title').innerHTML = dataName;
        this.selectbox.parentElement.submit();
    }

    initSelectbox() {
        var selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
            titleElement = this.element.querySelector('.RevolutionDropdown--Title');
        if (selectedItem && titleElement) {
            titleElement.innerHTML = selectedItem.getAttribute('data-name');
        }
        trapFocus(this.element);
        this.element.style.display = "block";

    }

    toggleDropdown(event, target) {
        event.preventDefault();
        var isOpen = target.getAttribute("aria-expanded") === "true";
        if (isOpen) {
            this.closeDropdown(event, target);
        } else {
            this.openDropdown(target);
        }
    }

    openDropdown(target) {
        this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
        var siblings = new DomHelper().getSiblings(target.parentElement, '.RevolutionDropdown');
        siblings.forEach(function (item) {
            item.querySelector('.RevolutionDropdown--Button').setAttribute("aria-expanded", false);
            item.querySelector('.RevolutionDropdown--Content').setAttribute("aria-hidden", true);
            item.querySelector('.RevolutionDropdown--Content').style.display = "none";

        });

        if (this.popover == true) {
            this.pageOverlayElement.classList.add("is-visible");
            this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);

            Utility.bodyScrollLockDisable(this.element);
            trapFocus(this.mainDropdown);
        }

        target.setAttribute("aria-expanded", true);
        target.parentElement.querySelector('.RevolutionDropdown--Content').setAttribute("aria-hidden", false);
        if(target.closest('.FiltersDesktopWrapper')){
            target.parentElement.querySelector('.RevolutionDropdown--Content').style.display = "flex";
        } else {
            target.parentElement.querySelector('.RevolutionDropdown--Content').style.display = "block";
        }

        window.addEventListener("click", this.onClickOutsideListener);
    }

    closeDropdown(event, target) {
        let closestDropdown = target.closest(".RevolutionDropdown");
        if (!closestDropdown) closestDropdown = target.querySelector("[aria-expanded='true']").parentElement;

        closestDropdown.querySelector('.RevolutionDropdown--Button').setAttribute("aria-expanded", false);
        closestDropdown.querySelector('.RevolutionDropdown--Content').setAttribute("aria-hidden", true);
        setTimeout(() => { closestDropdown.querySelector('.RevolutionDropdown--Content').style.display = "none"; }, 300);

        if (this.popover == true) {
            this.pageOverlayElement.classList.remove("is-visible");
            this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
            Utility.bodyScrollLockClear();
            document.body.classList.remove('scrollLock');
        }

        removeTrapFocus(this.mainDropdownContent);
        window.removeEventListener("click", this.onClickOutsideListener);
    }

}

class Form {
    constructor() { }

    serialize(form) {
        function stringKey(key, value) {
            var beginBracket = key.lastIndexOf("[");

            if (beginBracket === -1) {
                var _hash = {};
                _hash[key] = value;
                return _hash;
            }

            var newKey = key.substr(0, beginBracket);
            var newValue = {};

            newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

            return stringKey(newKey, newValue);
        }

        var hash = {};

        for (var i = 0, len = form.elements.length; i < len; i++) {
            var formElement = form.elements[i];

            if (formElement.name === "" || formElement.disabled) {
                continue;
            }

            if (
                formElement.name &&
                !formElement.disabled &&
                (formElement.checked ||
                    /select|textarea/i.test(formElement.nodeName) ||
                    /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                        formElement.type
                    ))
            ) {
                var stringKeys = stringKey(formElement.name, formElement.value);
                hash = this.extend(hash, stringKeys);
            }
        }

        return hash;
    }
    extend() {
        var extended = {};
        var i = 0;

        // Merge the object into the extended object
        var merge = function merge(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    // If property is an object, merge properties
                    if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
                        extended[prop] = Form.extend(extended[prop], obj[prop]);
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        // Loop through each object and conduct a merge
        for (; i < arguments.length; i++) {
            merge(arguments[i]);
        }

        return extended;
    }
}

class AddToCart {
    constructor(element) {
        this.element = element;
        this.delegateElement = new Delegate(this.element);
        this.pageLoader = document.body.querySelector(".pageLoader");
        this.bindEvents();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            "[data-action=add-to-cart]",
            this.addToCart.bind(this)
        );
        this.delegateElement.on(
            "submit",
            'form[action="/cart/addall"]',
            this.addAllToCart.bind(this)
        );
        this.delegateElement.on(
            "click",
            "[data-action=add-all-to-cart]",
            this.addAllToCart.bind(this)
        );
    }

    async addToCart(event) {
        event.preventDefault();
    
        const addToCartButton = event.target;
        this.pageLoader.style.width = "100%";
        addToCartButton.setAttribute("disabled", "disabled");
    
        const formElement = event.target.closest("form");
        formElement.querySelector('[name="id"]').removeAttribute('disabled');
    
        const formHelper = new Form();
        const serialized = formHelper.serialize(formElement);
    
        try {
            const response = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: JSON.stringify(serialized),
            });
    
            if (!response.ok) {
                const content = await response.json();
                this.showError(content.description, addToCartButton);
                return;
            }

            addToCartButton.removeAttribute("disabled");
            this.element.dispatchEvent(new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                    variant: serialized.id,
                    quantity: serialized.quantity,
                },
            }));

            // Refresh page only if URL ends with /cart
            if (window.location.pathname.endsWith("/cart")) {
                window.location.reload();
            }

        } catch (error) {
            console.error('Error adding to cart:', error);
        } finally {
            this.resetPageLoader();
        }
    }

    async addAllToCart(event) {
        event.preventDefault(); // Prevent form submission
    
        const addToCartButton = this.element.querySelector(".AddToCartAjax");
    
        // Switch the status of the button
        addToCartButton.setAttribute("disabled", "disabled");
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
    
        // Add the product via Ajax
        const formElement = event.target.closest("form");
        const formHelper = new Form();
        const formElementSerialized = formHelper.serialize(formElement);
        const items = this.extractItems(formElementSerialized);
    
        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: JSON.stringify({ items }),
            });
    
            if (!response.ok) {
                const content = await response.json();
                this.showErrorAllAddToCart(content.description, addToCartButton);
                return;
            }

            addToCartButton.removeAttribute("disabled");
            // Trigger an event so the mini-cart can re-render
            this.element.dispatchEvent(new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                    variant: this.currentVariant,
                    quantity: items.length,
                },
            }));

            // Refresh page only if URL ends with /cart
            if (window.location.pathname.endsWith("/cart")) {
                window.location.reload();
            }

        } catch (error) {
            console.error('Error adding all to cart:', error);
        }
    }

    showError(message, addToCartButton) {
        const errorElement = this.element.querySelector('.ProductForm--Error') || this.createErrorMessageElement(message, addToCartButton);
        errorElement.classList.add('visible');
    
        setTimeout(() => {
            errorElement.classList.remove('visible');
        }, 2500);
    }

    createErrorMessageElement(message, addToCartButton) {
        const errorMessageElement = document.createElement("span");

        errorMessageElement.className = "u-p4 accent";
        errorMessageElement.innerHTML = message;

        addToCartButton.removeAttribute("disabled");
        addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
    
        setTimeout(() => {
            errorMessageElement.remove();
        }, 2500);
    
        return errorMessageElement;
    }

    resetPageLoader() {
        this.pageLoader.style.left = "unset";
        this.pageLoader.style.right = "0px";
        this.pageLoader.style.width = "0%";
    
        setTimeout(() => {
            this.pageLoader.style.left = "0px";
            this.pageLoader.style.right = "unset";
        }, 550);
    }

    extractItems(formElementSerialized) {
        const items = [];
        const keys = Object.keys(formElementSerialized);
    
        keys.forEach((key) => {
            if (key !== "event_id") {
                const productElement = document.body.querySelector(`[name="${key}"]`);
                const productID = productElement ? productElement.getAttribute("data-id") : null;
    
                if (productID) {
                    let quantElement = document.body.querySelector(`#quantity--id_${productID}`);
                    let quant = quantElement ? quantElement.getAttribute("value") : 1;
                    items.push({ id: productID, quantity: parseInt(quant, 10) });
                }
            }
        });
    
        return items;
    }
}


class Dropdown {
    constructor(element) {
        this.element = element;
        this.domDelegate = new Delegate(this.element);
        this.bindEvents();
    }

    bindEvents() {
        this.domDelegate.on(
            "click",
            "[data-action=toggle-dropdown]",
            this.toggleDropdown.bind(this)
        );
    }
    openDropdown(elem) {
        const dropdownButton = elem.querySelector(".DropdownButton"),
            dropdownContent = elem.querySelector(".DropdownContent");

        dropdownButton.setAttribute("aria-expanded", true);
        new RevolutionAnimation(dropdownContent, "true").slideDown();
    }

    closeDropdown(elem) {
        const dropdownButton = elem.querySelector(".DropdownButton"),
            dropdownContent = elem.querySelector(".DropdownContent");
        new RevolutionAnimation(dropdownContent, true).slideUp();
        dropdownButton.setAttribute("aria-expanded", false);
        setTimeout(function () {
            dropdownContent.setAttribute("aria-hidden", "true");
        }, 250);
    }
    toggleDropdown(event, target) {
        event.preventDefault();
        
        // Prevent multiple rapid clicks
        if (target.classList.contains("is-processing")) {
            return;
        }
    
        // Add a temporary class to indicate the dropdown is being processed
        target.classList.add("is-processing");
    
        const mainDropdown = target.closest(".Dropdown");
        const isOpen = target.getAttribute("aria-expanded") === "true";
    
        if (isOpen) {
            this.closeDropdown(mainDropdown, target);
        } else {
            this.openDropdown(mainDropdown, target);
        }
    
        // Remove the processing class after a short delay
        setTimeout(() => {
            target.classList.remove("is-processing");
        }, 300); 
    }
    
}

(function (funcName, baseObj) {
    "use strict";
    // The public function name defaults to window.docReady
    // but you can modify the last line of this function to pass in a different object or method name
    // if you want to put them in a different namespace and those will be used instead of
    // window.docReady(...)
    funcName = funcName || "docReady";
    baseObj = baseObj || window;
    var readyList = [];
    var readyFired = false;
    var readyEventHandlersInstalled = false;

    // call this when the document is ready
    // this function protects itself against being called more than once
    function ready() {
        if (!readyFired) {
            // this must be set to true before we start calling callbacks
            readyFired = true;
            for (var i = 0; i < readyList.length; i++) {
                // if a callback here happens to add new ready handlers,
                // the docReady() function will see that it already fired
                // and will schedule the callback to run right after
                // this event loop finishes so all handlers will still execute
                // in order and no new ones will be added to the readyList
                // while we are processing the list
                readyList[i].fn.call(window, readyList[i].ctx);
            }
            // allow any closures held by these functions to free
            readyList = [];
        }
    }

    function readyStateChange() {
        if (document.readyState === "complete") {
            ready();
        }
    }

    // This is the one public interface
    // docReady(fn, context);
    // the context argument is optional - if present, it will be passed
    // as an argument to the callback
    baseObj[funcName] = function (callback, context) {
        if (typeof callback !== "function") {
            throw new TypeError("callback for docReady(fn) must be a function");
        }
        // if ready has already fired, then just schedule the callback
        // to fire asynchronously, but right away
        if (readyFired) {
            setTimeout(function () {
                callback(context);
            }, 1);
            return;
        } else {
            // add the function and context to the list
            readyList.push({ fn: callback, ctx: context });
        }
        // if document already ready to go, schedule the ready function to run
        // IE only safe when readyState is "complete", others safe when readyState is "interactive"
        if (
            document.readyState === "complete" ||
            (!document.attachEvent && document.readyState === "interactive")
        ) {
            setTimeout(ready, 1);
        } else if (!readyEventHandlersInstalled) {
            // otherwise if we don't have event handlers installed, install them
            if (document.addEventListener) {
                // first choice is DOMContentLoaded event
                document.addEventListener("load", ready, false);
                // backup is window load event
                window.addEventListener("DOMContentLoaded", ready, false);
            } else {
                // must be IE
                document.attachEvent("onreadystatechange", readyStateChange);
                window.attachEvent("onload", ready);
            }
            readyEventHandlersInstalled = true;
        }
    };
})("docReady", window);
// modify this previous line to pass in your own method name
// and object for the method to be attached to

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');

        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');

    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
        )
    );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);
    if (first) {
        first.focus();
    } else {
        elementToFocus.focus();
    }



}



function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}


class DomHelper {
    constructor() { }
    getSiblings(element, filter) {
        var includeSelf =
            arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var siblings = [];
        var currentElement = element;

        // Do the previous first
        while ((currentElement = currentElement.previousElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }

        if (includeSelf) {
            siblings.push(element);
        }

        // Then the next side
        currentElement = element;

        while ((currentElement = currentElement.nextElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }

        return siblings;
    }

    nodeListToArray(nodeList, filter) {
        var items = [];

        for (var i = 0; i !== nodeList.length; ++i) {
            if (!filter || nodeList[i].matches(filter)) {
                items.push(nodeList[i]);
            }
        }

        return items;
    }
    outerWidthWithMargin(element) {
        var width = element.offsetWidth,
            style = getComputedStyle(element);

        width += parseInt(style.marginLeft) + parseInt(style.marginRight);

        return width;
    }
    outerHeightWithMargin(element) {
        var height = element.offsetHeight,
            style = getComputedStyle(element);

        height += parseInt(style.marginTop) + parseInt(style.marginBottom);

        return height;
    }
}

class Responsive {
    constructor() {
        var _this = this;

        this.currentBreakpoint = this.getCurrentBreakpoint();

        window.addEventListener("resize", function () {
            var newBreakpoint = _this.getCurrentBreakpoint();

            if (_this.currentBreakpoint === newBreakpoint) {
                return;
            }

            document.dispatchEvent(
                new CustomEvent("breakpoint:changed", {
                    detail: {
                        previousBreakpoint: _this.currentBreakpoint,
                        currentBreakpoint: newBreakpoint,
                    },
                })
            );

            _this.currentBreakpoint = newBreakpoint;
        });
    }

    matchesBreakpoint(breakpoint) {
        switch (breakpoint) {
            case "phone":
                return window.matchMedia("screen and (max-width: 640px)").matches;

            case "tablet":
                return window.matchMedia(
                    "screen and (min-width: 641px) and (max-width: 1024px)"
                ).matches;

            case "tablet-and-up":
                return window.matchMedia("screen and (min-width: 768px)").matches;

            case "pocket":
                return window.matchMedia("screen and (max-width: 1024px)").matches;

            case "lap-and-up":
                return window.matchMedia("screen and (min-width: 1024px)").matches;

            case "desk":
                return window.matchMedia("screen and (min-width: 1280px)").matches;

            case "widescreen":
                return window.matchMedia("screen and (min-width: 1600px)").matches;
        }
    }
    getCurrentBreakpoint() {
        if (window.matchMedia("screen and (max-width: 640px)").matches) {
            return "phone";
        }

        if (
            window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
                .matches
        ) {
            return "tablet";
        }

        if (
            window.matchMedia(
                "screen and (min-width: 1008px) and (max-width: 1279px)"
            ).matches
        ) {
            return "lap";
        }

        if (window.matchMedia("screen and (min-width: 1280px)").matches) {
            return "desk";
        }
    }
}
class RevolutionImage {
    constructor() { }

    getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === "master") {
            return src.replace(/http(s)?:/, "");
        }

        var match = src.match(
            /\.(jpg|webp|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
        );

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
        } else {
            return null;
        }
    }
    getSupportedSizes(image, desiredSizes) {
        var supportedSizes = [],
            imageWidth = image["width"];

        desiredSizes.forEach(function (width) {
            if (imageWidth >= width) {
                supportedSizes.push(width);
            }
        });

        return supportedSizes;
    }
}

class RevolutionSwiper {
    constructor(element, additionalSwiper) {

        var options =
            arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.element = element;
        this.thumb = additionalSwiper;
        this.initialConfig = JSON.parse(
            element.getAttribute("data-swiper-settings")
        );

        if (additionalSwiper) {
            this.initialConfigThumbs = JSON.parse(
                additionalSwiper.getAttribute("data-swiper-thumb-settings")
            );
        }
        this.options = options;
        this.build();
    }


    selectCell(index) {


        this.swiperElement.slideTo(index);
    }

    resize() {
        this.swiperElement.resize();
    }


    build() {
        var _this = this,
            configThumb = this.initialConfigThumbs;
        if (configThumb != null) {
            this.thumbSwiper = new Swiper(this.thumb, configThumb);
            this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
        }
        this.swiperElement = new Swiper(this.element, this.initialConfig);
        this.selectedIndex = this.swiperElement.activeIndex;

        this.swiperElement.on('slideChange', function () {
            _this.element.dispatchEvent(
                new CustomEvent("swiper:slide-changed", {
                    bubbles: true,
                    detail: {
                        currentIndex: _this.swiperElement.activeIndex,
                        element: _this.swiperElement.el,
                        isEnd: _this.swiperElement.isEnd,
                        isBeginning: _this.swiperElement.isBeginning
                    }
                })
            );
        });
    }
}


class Drawer {
    constructor(element) {
        var options =
            arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.element = element;
        this.delegateElement = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);
        this.pageOverlayElement = document.querySelector(".pageOverlay");

        if (navigator.platform === "iPhone")
            document.documentElement.style.setProperty(
                "--viewport-height",
                `${window.innerHeight}px`
            );
        this.onOpen = options["onOpen"] || function () { };
        this.onClose = options["onClose"] || function () { };
        this.isOpen = false;

        if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
            new RevolutionAnimation(this.element);
          }


        this.bindEvents();
    }

    bindEvents() {
        this.delegateBody.on(
            "click",
            '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
            this.openDrawer.bind(this)
        );
        this.delegateBody.on(
            "click",
            '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
            this.closeDrawer.bind(this)
        );
        this.delegateBody.on(
            "click",
            '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
            this.toggleDrawer.bind(this)
        );
        this._openListener = this.openDrawer.bind(this);
        this._closeListener = this.closeDrawer.bind(this);
        this.calculateMaxHeightListener = this.maxHeight.bind(this);
        window.addEventListener("resize", this.calculateMaxHeightListener);
    }

    maxHeight() {
        this.element.style.height = window.innerHeight + "px";
        if (
            this.element.getAttribute("id") == "cart" ||
            this.element.getAttribute("id") == "sidebarFavorites"
        ) {
            var footer = this.element.querySelector(
                ".CartDrawer--Footer"
            );
            var footerHeight = 0;
            if (footer !== null) {
                footerHeight = footer.offsetHeight;
            }

            var header = this.element.querySelector(".CartHeader").offsetHeight;
            var cartItem = this.element.querySelector(".cart-item");
            if (cartItem !== null) {
                var itemHeight = cartItem.offsetHeight;
            }

            var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

            if (itemWrapper !== null) {
                itemWrapper.style.height = window.innerHeight - footerHeight - header + "px";
            }
        }
    }

    toggleDrawer() {
        event.preventDefault();
        this.isOpen ? this.closeDrawer() : this.openDrawer();
    }

    openDrawer() {
        this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));

        if (event && event.target.dataset.country){
            const pinpoint = document.body
                .querySelector(`.locationPin[data-country="${event.target.dataset.country}"] img`);
            pinpoint.src = window.map.location_pin_active;
        }

        this.breakpoint = new Responsive().getCurrentBreakpoint();
        const id = this.element.getAttribute("id");
        let focus = null;

        switch (id) {
            case "cart":
                this.handleCartOpen();
                focus = this.element.querySelector(".CartItems--Wrapper, .CartItems--EmptyWrapper");
                break;
        
            case "sidebarDrawer":
                this.handleSidebarDrawerOpen();
                break;

            case "favoritesDrawer":
                this.handleFavoritesDrawerOpen();
                break;
        }

        if (this.isOpen) return;
        
        this.closeAllDrawers();
        this.maxHeight();

        this.element.setAttribute("aria-expanded", "true");
        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.addEventListener("click", this._closeListener);

        Utility.bodyScrollLockDisable(focus || this.element);

        this.isOpen = true;
        trapFocus(this.element);
        this.onOpen();
        return false;
    }

    closeDrawer(event) {
        if (!this.isOpen) {
            return;
        }
        if (event) {
            event.preventDefault();
        }

        if (this.element.getAttribute('data-country')){

          const pinpoint = document.body
          .querySelector(`.locationPin[data-toggle-id="${this.element.getAttribute('id')}"] img`);
          pinpoint.src = window.map.location_pin_nonactive;
        }
        document.body.classList.remove('scrollLock');
        Utility.bodyScrollLockClear();
        if (this.element.getAttribute("id") == "cart") {
          var options = JSON.parse(this.element.getAttribute("data-settings"));
          if(options['showRecommendations']){
            this.element
                .querySelector(".CartDrawer--Expendable")
                .setAttribute("aria-expanded", false);
                setTimeout(() => {    this.element.querySelector('.CustomCart__Recommendations').innerHTML = ""}, 800);

          }

        }
        this.element.setAttribute("aria-expanded", "false");
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener("click", this._closeListener);
        removeTrapFocus(this.element);
        this.closeAnimation(this.element);
        this.isOpen = false;
        this.onClose();
    }

    closeAllDrawers() {
        const drawers = document
            .querySelectorAll('.Drawer--wrapper[aria-expanded="true"], .inspirationDrawer_Wrapper[aria-expanded="true"]', '#favoritesDrawer[aria-expanded="true"]');

        drawers.forEach((item, _i) => {
            item.setAttribute("aria-expanded", "false");
            removeTrapFocus(item);
            this.closeAnimation(item);
            item.isOpen = false;
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest("details");
        this.closeSubmenu(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute("open");
                if (detailsElement.closest("details[open]")) {
                    trapFocus(
                        detailsElement.closest("details[open]"),
                        detailsElement.querySelector("summary")
                    );
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }

    handleCartOpen() {            
        this.element.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
        const count = window.theme.cartCount;
   
        if (count > 0 && this.breakpoint != 'phone') {
            this.element
                .querySelector(".CartDrawer--Expendable")
                .setAttribute("aria-expanded", true);

        }
    }

    handleSidebarDrawerOpen() {
        document.querySelector(".SidebarDrawer__Close").style.display = "block";
        this.element.dispatchEvent(
          new CustomEvent("sidebar-drawer:open", {
            bubbles: true,
          })
        );
    }

    handleFavoritesDrawerOpen() {
        this.element.dispatchEvent(
            new CustomEvent("favorite-product:open", {
              bubbles: true,
            })
          );
    }
}


class RevolutionAnimation {
    constructor(element, directAnimation) {
        this.element = element;
        if (!directAnimation) {
            this.intersectionObserver = [];
            var contentToAnimate = this.element.querySelectorAll('[data-animation]');
            contentToAnimate.forEach((item, i) => {
                this.setupAnimation(item, i);
            });

        }


    }
    slideUp() {
        this.element.style.height = this.element.scrollHeight + "px";
        this.element.offsetHeight;
        this.element.style.height = 0;
    }

    slideDown() {
        if (this.element.style.height === "auto") {
            return;
        }
        var _this = this;
        this.element.style.height = this.element.scrollHeight + "px";
        this.element.setAttribute("aria-hidden", false);
        var transitionEnded = function transitionEnded(event) {
            if (event.propertyName === "height") {
                _this.element.style.height = "auto";
                _this.element.removeEventListener("transitionend", transitionEnded);
            }
        };

        this.element.addEventListener("transitionend", transitionEnded);
    }

    elementScaleOut(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute('data-loaded')) { return; }
            setTimeout(() => {

                var elementMove = [
                    // keyframes
                    { transform: 'scale(104%)', opacity: '0' },
                    { transform: 'scale(100%)', opacity: '1' }
                ];
                item.animate(
                    elementMove
                    , {
                        // timing options
                        duration: window.theme.animationDuration * 2,
                        fill: 'forwards'
                    });

            }, window.theme.animationBetweenElements * i);
            item.setAttribute('data-loaded', true);
        });


    }

    elementScaleIn(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute('data-loaded')) { return; }
            setTimeout(() => {

                var elementMove = [
                    // keyframes
                    { transform: 'scale(96%)', opacity: '0' },
                    { transform: 'scale(100%)', opacity: '1' }
                ];
                item.animate(
                    elementMove
                    , {
                        // timing options
                        duration: window.theme.animationDuration * 2,
                        fill: 'forwards'
                    });

            }, window.theme.animationBetweenElements * i);
            item.setAttribute('data-loaded', true);
        });


    }

    elementFromTop(toReveal) {
        toReveal.forEach((item, i) => {
            console.log(item);
            
            if (item.getAttribute('data-loaded')) { return; }
            setTimeout(() => {

                var elementMove = [
                    // keyframes
                    { transform: 'translateY(-30px)', opacity: '0' },
                    { transform: 'translateY(0px)', opacity: '1' }
                ];
                item.animate(
                    elementMove
                    , {
                        // timing options
                        duration: window.theme.animationDuration,
                        fill: 'forwards'
                    });

            }, window.theme.animationBetweenElements * i);
            item.setAttribute('data-loaded', true);
        });


    }

    elementFromBottom(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute('data-loaded')) { return; }
            setTimeout(() => {

                var elementMove = [
                    // keyframes
                    { transform: 'translateY(30px)', opacity: '0' },
                    { transform: 'translateY(0px)', opacity: '1' }
                ];
                item.animate(
                    elementMove
                    , {
                        // timing options
                        duration: window.theme.animationDuration,
                        fill: 'forwards'
                    });

            }, window.theme.animationBetweenElements * i);
            item.setAttribute('data-loaded', true);
        });


    }

    elementFromRight(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute('data-loaded')) { return; }
            setTimeout(() => {

                var elementMove = [
                    // keyframes
                    { transform: 'translateX(30px)', opacity: '0' },
                    { transform: 'translateX(0px)', opacity: '1' }
                ];
                item.animate(
                    elementMove
                    , {
                        // timing options
                        duration: window.theme.animationDuration,
                        fill: 'forwards'
                    });
                item.setAttribute('data-loaded', true);
            }, window.theme.animationBetweenElements * i);

        });


    }
    elementFromLeft(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute('data-loaded')) { return; }
            setTimeout(() => {

                var elementMove = [
                    // keyframes
                    { transform: 'translateX(-30px)', opacity: '0' },
                    { transform: 'translateX(0px)', opacity: '1' }
                ];
                item.animate(
                    elementMove
                    , {
                        // timing options
                        duration: window.theme.animationDuration,
                        fill: 'forwards'
                    });
                item.setAttribute('data-loaded', true);
            }, window.theme.animationBetweenElements * i);

        });


    }
    elementFromRightBig(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute('data-loaded')) { return; }
            setTimeout(() => {

                var elementMove = [
                    // keyframes
                    { transform: 'translateX(120px)', opacity: '0' },
                    { transform: 'translateX(0px)', opacity: '1' }
                ];
                item.animate(
                    elementMove
                    , {
                        // timing options
                        duration: window.theme.animationDuration,
                        fill: 'forwards'
                    });
                item.setAttribute('data-loaded', true);
            }, window.theme.animationBetweenElements * i);

        });


    }
    elementFromLeftBig(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute('data-loaded')) { return; }
            setTimeout(() => {

                var elementMove = [
                    // keyframes
                    { transform: 'translateX(-120px)', opacity: '0' },
                    { transform: 'translateX(0px)', opacity: '1' }
                ];
                item.animate(
                    elementMove
                    , {
                        // timing options
                        duration: window.theme.animationDuration,
                        fill: 'forwards'
                    });

            }, window.theme.animationBetweenElements * i);
            item.setAttribute('data-loaded', true);
        });


    }
    setupAnimation(animatedItem, i) {
        var options = [],
            query = "";
        options["integer"] = i;
        options["type"] = animatedItem.getAttribute('data-animation');


        var _this = this;
        if (this.intersectionObserver[i]) {
            this.intersectionObserver[i].disconnect();
        }
        this.intersectionObserver[i] = new IntersectionObserver(
            this.reveal.bind(this, options),
            {
                threshold: 0.3
            }
        );
        if (window.theme.enableImageAnimations) {
            query = ".animatedContent";
        }
        new DomHelper()
            .nodeListToArray(animatedItem.querySelectorAll(".animatedContent, .animatedContent"))
            .forEach(function (item) {

                _this.intersectionObserver[i].observe(item);
            });

    }

    reveal(a, results) {
        var _this = this;
        var integer = a['integer'];
        var toReveal = [];
        results.forEach(function (result) {

            if (result.isIntersecting || result.intersectionRatio > 0) {
                // isIntersecting does not exist on Samsung Android browser
                toReveal.push(result.target);
                _this.intersectionObserver[integer].unobserve(result.target);
            }
        });

        if (toReveal.length === 0) {
            return;
        }

        switch (a['type']) {
            case "elementFromTop":
                this.elementFromTop(toReveal);
                break;

            case "elementFromBottom":
                this.elementFromBottom(toReveal);
                break;

            case "elementFromRight":
                this.elementFromRight(toReveal);
                break;

            case "elementFromLeft":
                this.elementFromLeft(toReveal);
                break;
            case "elementFromLeftBig":
                this.elementFromLeftBig(toReveal);
                break;
            case "elementFromRightBig":
                this.elementFromRightBig(toReveal);
                break;
            case "elementScaleIn":
                this.elementScaleIn(toReveal);
                break;
            case "elementScaleOut":
                this.elementScaleOut(toReveal);
        }


    }
}

class FavoritesDrawer extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      this.sidebarDrawer = new Drawer(this.element);
      this.delegateBody = new Delegate(document.body);
      this.options = JSON.parse(this.element.getAttribute("data-settings"));
      this.loader = this.element.querySelector(".loader");
      this.cartCount = document.querySelector(".FavoritesCount");
      if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
        new RevolutionAnimation(this.element);
      }
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.toggleFavorites();
      this.bindEvents();
    }
    unbindEvents(){
          document.removeEventListener('favorite-product:open', this.onFavoritesOpenListener);

            document.removeEventListener(
            'click',
              this._addToFavoritesL
            );

    }
    bindEvents(){


   if(!document.body.classList.contains('listener')){
     this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
     this._addToFavoritesL =  this.addToFavorites.bind(this);
  this.delegateBody.on('click', '[data-action="toggle-favorites"]', this._addToFavoritesL);
       document.body.classList.add('listener');
      document.addEventListener('favorite-product:open', this.onFavoritesOpenListener);

   }


    }


    onFavoritesOpen() {
      var _this = this;
      this.rerenderFavorites().then(function () {
        new AddToCart(_this.element);
      });
      this.sidebarDrawer.isOpen = true;
    }

    maxHeight() {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      if(footer){
        var footerH = footer.offsetHeight;
      }
      var header = this.element.querySelector(".CartHeader").offsetHeight;
      this.element.querySelector(".CartItems--Wrapper").style.height =
        window.innerHeight - footerH + "px";
    }

    getSearchQueryStrings() {
      var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
      // If we are on a product template, we make sure to remove the main product from the related product
      const bucketSize = 10.0;
      const idBuckets = [];
      items.forEach((id, index) => {
        const key = Math.floor(index / bucketSize);
        if (!idBuckets[key]) {
          idBuckets[key] = [];
        }
        idBuckets[key].push(id);
      });
      return idBuckets.reduce((acc, vall) => {
        const string = vall
          .map(function (id) {
            return "id:" + id;
          })
          .join(" OR ");

        acc.push(string);
        return acc;
      }, []);
    }

    rerenderFavorites(_event, _elementToAnimate) {
      this.loader.classList.add("is-visible");
      var _this32 = this;
      var queryStrings = this.getSearchQueryStrings();
      const promises = [];
      if (queryStrings.length == 0) {
        this.loader.classList.remove("is-visible");
        fetch("/?section_id=favorites-drawer").then(function (content) {
          content.text().then(function (html) {
            _this32.replaceContentFav(html);
            _this32.loader.classList.remove("is-visible");
            _this32.loadRecommendations();
          });
        });

      }
      queryStrings.forEach((string) => {
        promises.push(
          fetch("/search?view=favorites&type=product&q=" + string, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      });
      promises.reduce(async (_acc, val, _index) => {
        const content = await val.then((response) => response.text());
        const container = this.element;
        if (!container.length) {
          _this32.replaceContentFav(content);
          _this32.loader.classList.remove("is-visible");
          _this32.maxHeight();
        } else {
          this.loader.classList.remove("is-visible");
        }
      }, Promise.resolve());

      return Promise.resolve();
    }

    replaceContentFav(html) {
      var tempElement = document.createElement("div");
      tempElement.innerHTML = html;
      var number = tempElement
        .querySelector(".countFav")
        .getAttribute("data-count");
      var cartNodeParent = this.element.querySelector(".CartDrawer");
      cartNodeParent.replaceChild(
        tempElement.querySelector("#cartData"),
        this.element.querySelector("#cartData")
      );
      this.toggleFavorites();
      this.loader.classList.remove("is-visible");
      return true;
    }

    toggleFavorites() {
      var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
      var favorites = document.querySelectorAll(".ProductCard--Favorites");

      if(items.length > 0 ){
        document.body.querySelector('.emptyHearthH').style.display = "none";
        document.body.querySelector('.brokenHearthH').style.display = "flex";
      }else{
        document.body.querySelector('.emptyHearthH').style.display = "flex";
        document.body.querySelector('.brokenHearthH').style.display = "none";
      }
      favorites.forEach(function (item) {
        var state = item.getAttribute("state");
        var myID = item.getAttribute("data-id");

        if (state == "not-active" && items.includes(myID)) {
          item.querySelector(".brokenHearth").style.display = "flex";
          item.querySelector(".emptyHearth").style.display = "none";
          item.setAttribute("state", "active");
        } else if (!items.includes(myID)) {
          item.querySelector(".brokenHearth").style.display = "none";
          item.querySelector(".emptyHearth").style.display = "flex";
          item.setAttribute("state", "not-active");
        }
      });
    }

    removeFromFavorites(productId) {
      var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
      items = items.filter((c) => c != productId);

      try {
        localStorage.setItem(
          "productFavorites",
          JSON.stringify(items.slice(0, 50))
        );
      } catch (error) {
        console.log(error);
      }
      var _this = this;
      this.toggleFavorites();
      if (this.sidebarDrawer.isOpen == true) {
        this.rerenderFavorites().then(function () {
          new AddToCart(_this.element);
        });
      }
    }

    loadRecommendations() {
      var _this = this;
      if(this.options['productId'] == ''){
      var url =
        "/recommendations/products?section_id=cart-recommendations&product_id=" +
        this.options["productId"] +
        "&limit=6";
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement("div");
          container.innerHTML = content;

          if(container){
          var z = container.querySelector(".cartUpsell").innerHTML;
            var x = _this.element.querySelector(".FavoritesRecommendations");
            x.innerHTML = z;
          }

          _this.carouselElement = _this.element.querySelector(".swiper");
          _this.carousel = new RevolutionSwiper(_this.carouselElement);

          new AddToCart(x);
          _this.toggleFavorites();
        });
      });
    }
    }


    addToFavorites(event) {
        var _this = this;
      event.preventDefault();

      var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
      var productId = event.target.getAttribute("data-id");

      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId) && productId != "") {
        items.unshift(productId);
      } else {
        this.removeFromFavorites(productId, false);
        //   this._favoritesNumber();
        return;
      }
      // Then, we save the current product into the local storage, by keeping only the 50 most recent
      try {
        localStorage.setItem(
          "productFavorites",
          JSON.stringify(items.slice(0, 50))
        );
        //    this._favoritesNumber();
        this.toggleFavorites();
        if (this.sidebarDrawer.isOpen == true) {
      this.rerenderFavorites().then(function () {
        new AddToCart(_this.element);
      });  }
      } catch (error) {
        // Do nothing, this may happen in Safari in incognito mode
      }
    }
  }
  customElements.define("favorites-drawer", FavoritesDrawer);


class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value)
            this.input.dispatchEvent(this.changeEvent);

            console.log(previousValue)
    }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = (form) => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
    country_domid,
    province_domid,
    options
) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(
        options["hideElement"] || province_domid
    );

    Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
    );

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (_e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

class ProductForm extends HTMLElement {
    constructor() {
        super();
        new AddToCart(this);
    }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.counter = 0;
        this.counter = this.element.querySelector(".counter");
        this.options = JSON.parse(this.element.getAttribute("data-settings"));
        const countInterval = setInterval(this.countDown.bind(this), 1000);

    }

    countDown() {
        const dateNow = new Date();
        const countDate = new Date(
            "March 3, 2030," + this.options["countdownTime"]
        );
        const nOfDays = this.options["countdownDays"];
        const difference = countDate - dateNow;

        var textDays = 0;
        const seconds = 1000;
        const minutes = seconds * 60;
        const hours = minutes * 60;
        const days = hours * 24;
        const todaysDay = dateNow.getDay();

        const textHours = Math.floor((difference % days) / hours);
        const textMinutes = Math.floor((difference % hours) / minutes);
        const textSeconds = Math.floor((difference % minutes) / seconds);

        if (todaysDay == 1) {
            textDays = nOfDays;
        } else if (todaysDay == 0) {
            textDays = 0;
        } else {
            textDays = nOfDays - todaysDay;
            if (textDays < 0) {
                const mDays = todaysDay % nOfDays;
                textDays = nOfDays - mDays;
            }
        }

        if (this.options["excludeWeekends"] && todaysDay == 5) {
            textDays = textDays + 2;
        } else if (this.options["excludeWeekends"] && todaysDay == 6) {
            textDays = textDays + 1;
        }


        const displayHours = textHours;
        const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
        const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
        const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;
        if (textDays > 0 && nOfDays > 1) {
            this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
        } else {
            this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
        }


    }
}
customElements.define("countdown-element", Countdown);

class CartDrawer extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.assignVariables();
        this.bindEvents();
    }

    assignVariables() {
        this.delegateElement = new Delegate(this.element);
        this.delegateElement = new Delegate(this.element);
        this.sidebarDrawer = new Drawer(this.element);
        this.breakpoint = new Responsive().getCurrentBreakpoint();

        this.loader = this.element.querySelector(".itemLoader");
        this.cartCount = document.querySelector(".CartCount");
        this.options = JSON.parse(this.element.getAttribute("data-settings"));
        this.pageLoader = document.body.querySelector(".pageLoader");

        if (window.location.href.indexOf("?sideDrawer=true") > -1) {
          this.sidebarDrawer.openDrawer();
        }

        if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
          new RevolutionAnimation(this.element);
        }

        this.discount = this.element.querySelector('#discount');
        this.bundleDiscount = localStorage.getItem('bundleDiscount');

        if (this.bundleDiscount && this.discount){
            this.discount.value = this.bundleDiscount;
        }
    }

    onUnload() {
        this.delegateElement.off();
        document.removeEventListener("product:added", this.onProductAddedListener);
    }

    bindEvents() {
        if (window.theme.listener == "false") {
            this.onProductAddedListener = this.onProductAdded.bind(this);

            document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
            document.addEventListener("product:added", this.onProductAddedListener);

            this.delegateElement.on(
                "click",
                '[data-action="update-item-quantity"], [data-action="remove-item"]',
                this.updateItemQuantity.bind(this)
            );

            this.delegateElement.on(
                "change",
                ".QuantitySelector__CurrentQuantity",
                this.updateItemQuantity.bind(this)
            );

            this.delegateElement.on(
                "click",
                '[data-sec-action="disable-purchase"]',
                this.disableCheckout.bind(this)
            );

            window.theme.listener = "true";
        }
    }

    onOpen() {
      document.documentElement.style.setProperty('--cartHeader-height', document.querySelector('.CartHeader').offsetHeight + 'px');

      if(this.options['showRecommendations']) {
            if (this.breakpoint == "phone" || this.breakpoint == "tablet") {
                this.loadRecommendationsMobile();
            } else {
                this.loadRecommendations();
            }
      }
    
    }

    async updateItemQuantity(event, target) {
        event.preventDefault();

        const cartItem = target.closest('.cart-item');
        cartItem.querySelector('.itemLoader').classList.add("is-visible");

        let quantity;
        if (target.tagName === "INPUT") {
            quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
        } else {
            quantity = parseInt(target.getAttribute("data-quantity"));
        }

        try {
            await fetch(`${window.routes.localeRootUrl}/cart/update.js`, {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: JSON.stringify({
                    updates: {
                        [target.getAttribute("data-line-id")]: quantity,
                    }
                })
            });

            this.renderCart(target.getAttribute("data-id"), true);
        } catch (error) {
            console.error('Error updating item quantity:', error);
        }
    }


    onProductAdded() {
        var _this = this;
        this.renderCart().then(function () {
            _this.sidebarDrawer.openDrawer();
        });
    }

    async renderCart(lineNumber, quantityChange) {
        this.pageLoader.style.width = "100%";
    
        try {
            const response = await fetch(`${window.routes.localeRootUrl}/?section_id=cart-drawer`, {
                credentials: "same-origin",
                method: "GET",
            });
            const html = await response.text();
            this.replaceContent(html, lineNumber, quantityChange);

        } catch (error) {
            console.error('Error rendering cart:', error);
        }
    }
    
    replaceContent(html, lineNumber) {        
        this.pageLoader.style.left = "unset";
        this.pageLoader.style.right = "0px";
        this.pageLoader.style.width = "0%";
    
        setTimeout(() => {
            this.pageLoader.style.left = "0px";
            this.pageLoader.style.right = "unset";
        }, 550);
    
        const tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        this.tempOptions = JSON.parse(tempElement.querySelector('#cart').getAttribute("data-settings"));
    
        const cartUpsell = document.querySelector('cart-upsell');
        if (cartUpsell) {
            const tempCartUpsell = tempElement.querySelector('cart-upsell');
            this.tempOptionsPopup = tempCartUpsell.getAttribute("data-settings");
            this.tempOptionsPopupHandles = tempCartUpsell.getAttribute("data-carthandles");
    
            cartUpsell.setAttribute('data-settings', this.tempOptionsPopup);
            cartUpsell.setAttribute('data-carthandles', this.tempOptionsPopupHandles);
        }
    
        const itemCount = this.tempOptions['itemCount'];
        this.cartCount.innerHTML = `(${itemCount})`;
        window.theme.cartCount = parseInt(itemCount);
    
        if (lineNumber) {
            const cartNodeParent = this.element.querySelector(`#${lineNumber}`);
            const itemToReplaceWith = tempElement.querySelector(`#${lineNumber} .cartItem--Informations`);
            const itemLoader = cartNodeParent.querySelector('.itemLoader');
    
            if (itemLoader) {
                itemLoader.classList.remove('is-visible');
            }
    
            if (itemToReplaceWith) {
                cartNodeParent.replaceChild(itemToReplaceWith, cartNodeParent.querySelector('.cartItem--Informations'));
            } else {
                cartNodeParent.classList.add('removing');
                cartNodeParent.animate([
                    { transform: 'translateY(0px)', opacity: '1' },
                    { transform: 'translateY(30px)', opacity: '0' }
                ], {
                    duration: 500,
                    fill: 'forwards'
                });
                setTimeout(() => {
                    cartNodeParent.remove();
                }, 500);
            }
    
            if (this.bundleDiscount) {
                this.discount.value = this.bundleDiscount;
            }

            if (itemCount > 0) {
                const checkoutButtonParent = this.element.querySelector('.CartDrawer--Footer');
                const checkoutButtonToReplace = tempElement.querySelector('.cartCheckout--Button');
                checkoutButtonParent.replaceChild(checkoutButtonToReplace, checkoutButtonParent.querySelector('.cartCheckout--Button'));
    
                const checkoutBarParent = this.element.querySelector('progress-bar');
                const checkoutBarToReplace = tempElement.querySelector('.progress-bar-outer');
                checkoutBarParent.replaceChild(checkoutBarToReplace, checkoutBarParent.querySelector('.progress-bar-outer'));
    
                const checkoutBarParent2 = this.element.querySelector('.progress-bar-outerText');
                const checkoutTextToReplace = tempElement.querySelector('.mpa-message');
                checkoutBarParent2.replaceChild(checkoutTextToReplace, checkoutBarParent2.querySelector('.mpa-message'));

                if (this.options['showRecommendations']) {
                    if (this.breakpoint == "phone" || this.breakpoint == "tablet") {
                        this.loadRecommendationsMobile();
                    } else {
                        this.loadRecommendations();
                    }
                }
            } else {
                this.element.querySelector('.CartDrawer--Footer').classList.add('removing');
                const mainPartParent = this.element.querySelector('.CartDrawer');
                mainPartParent.innerHTML = tempElement.querySelector('.CartDrawer').innerHTML;
    
                if (this.options['showRecommendations']) {
                    if (this.breakpoint == "phone" || this.breakpoint == "tablet") {
                        this.loadRecommendationsMobile();
                    } else {
                        this.loadRecommendations();
                    }
                    this.element.querySelector(".CartDrawer--Expendable").setAttribute("aria-expanded", false);
                }
    
                if (window.theme.enableImageAnimations) {
                    const mainPartchildren = mainPartParent.querySelector('.CartItems--EmptyWrapper');
                    mainPartchildren.animate([
                        { opacity: '0' },
                        { opacity: '1' }
                    ], {
                        duration: 500,
                        fill: 'forwards'
                    });
                }
            }
    
            const itemLoaderGlobal = this.element.querySelector('.itemLoader');
            if (itemLoaderGlobal) {
                setTimeout(() => {
                    itemLoaderGlobal.classList.remove('is-visible');
                }, 250);
            }
        } else {
            const cartNodeParent = this.element.querySelector('.CartDrawer').parentNode;
            const currentScrollPosition = this.element.querySelector('#main-cart-items').scrollTop;
    
            cartNodeParent.replaceChild(tempElement.querySelector('.CartDrawer'), this.element.querySelector('.CartDrawer'));
            this.element.querySelector('#main-cart-items').scrollTop = currentScrollPosition;
    
            if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
                new RevolutionAnimation(this.element);
            }
        }
    
        setTimeout(() => {
            const focus = this.breakpoint !== "phone" ? 
                this.element.querySelector('[data-scrollable]') : this.element.querySelector(".CartItems--Wrapper, .CartItems--EmptyWrapper");

            if (focus) Utility.bodyScrollLockDisable(focus);            

            this.sidebarDrawer.maxHeight();
        }, 200);
    
        document.documentElement.style.setProperty('--cartFooter-height', `${this.element.querySelector('.CartDrawer--Footer').offsetHeight}px`);
    
        this.element.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }
    

    async loadRecommendations() {
        const productId = this.options['productId'];
        const url = productId
            ? `/recommendations/products?section_id=cart-recommendations&product_id=${productId}&limit=8`
            : "?section_id=cart-recommendations";
    
        try {
            const response = await fetch(url);
            const content = await response.text();
    
            const container = document.createElement("div");
            container.innerHTML = content;
            const recommendationsHTML = container.querySelector(".cartUpsell").innerHTML;
    
            let targetElement;
            if (window.theme.cartCount === 0) {
                targetElement = this.element.querySelector(".EmptyRecommendations");
            } else {
                targetElement = this.element.querySelector(".withItemRecommendations");
            }
    
            targetElement.innerHTML = recommendationsHTML;
    
            if (window.theme.cartCount === 0) {
                const id = container.querySelector('section').dataset.sectionid;
                new Swiper(".swiperUpsell", {
                    slidesPerView: 2,
                    spaceBetween: 16,
                    nested: true,
                    navigation: {
                        nextEl: `.swiperNextCart${id}`,
                        prevEl: `.swiperPrevCart${id}`,
                    },
                    pagination: {
                        el: ".swiperpaginationCart",
                        clickable: true
                    },
                    loop: false,
                    slidesOffsetAfter: 16,
                    slidesOffsetBefore: 16,
                    breakpoints: {
                        1024: {
                            slidesPerView: 2,
                            slidesOffsetAfter: 32,
                            slidesOffsetBefore: 32,
                            spaceBetween: 24,
                        },
                    },
                });
            }
    
            new AddToCart(targetElement);

            const focus = this.element.querySelector('.CartDrawer--Expendable [data-scrollable]');
            Utility.bodyScrollLockDisable(focus);
    
            if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
                new RevolutionAnimation(this.element);
            }
            this.widgetElement = this.element.querySelectorAll('[data-oke-star-rating]');
            this.widgetElement.forEach((item) => {
                window.okeWidgetApi.initWidget(item);
            })
       
        } catch (error) {
            console.error('Error loading recommendations:', error);
        }
    }

    async loadRecommendationsMobile() {
        const productId = this.options['productId'];
        const url = productId
            ? `/recommendations/products?section_id=cart-recommendations&product_id=${productId}&limit=8`
            : "?section_id=cart-recommendations";
    
        try {
            const response = await fetch(url);
            const content = await response.text();
    
            const container = document.createElement("div");
            container.innerHTML = content;
            const recommendationsHTML = container.querySelector(".cartUpsell").innerHTML;
            const id = container.querySelector('section').dataset.sectionid;
    
            const targetElement = this.element.querySelector(".EmptyRecommendations");
            targetElement.innerHTML = recommendationsHTML;
    
            new Swiper(".swiperUpsell", {
                slidesPerView: 2,
                spaceBetween: 16,
                nested: true,
                loop: false,
                slidesOffsetAfter: 16,
                slidesOffsetBefore: 16,
                navigation: {
                    nextEl: `.swiperNextCart${id}`,
                    prevEl: `.swiperPrevCart${id}`,
                },
                pagination: {
                    el: ".swiperpaginationCart",
                    clickable: true
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 2,
                        slidesOffsetAfter: 16,
                        slidesOffsetBefore: 16,
                        spaceBetween: 16,
                    },
                },
            });
    
            new AddToCart(targetElement);
    
            if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
                new RevolutionAnimation(this.element);
            }
            this.widgetElement = this.element.querySelectorAll('[data-oke-star-rating]');
            this.widgetElement.forEach((item) => {
                window.okeWidgetApi.initWidget(item);
            })
       
        } catch (error) {
            console.error('Error loading mobile recommendations:', error);
        }
    }    
    
    disableCheckout(event) {
        event.preventDefault();
        event.stopPropagation();
        const checkoutBtn = event.target;
        const minAmmount = checkoutBtn.dataset.min_amm ? parseFloat(checkoutBtn.dataset.min_amm) : 1;
        const cartTotal = checkoutBtn.dataset.total_price ? parseFloat(checkoutBtn.dataset.total_price) : 0;
        const form_id = checkoutBtn.getAttribute('form');
        const attr_name = checkoutBtn.getAttribute('name');

        if(cartTotal < minAmmount) {
            checkoutBtn.setAttribute('aria-disabled', true);
            return;
        }

        try {
          checkoutBtn.removeAttribute('data-sec-action');
          checkoutBtn.click();
        } catch (error) {
            console.error(error);
        }
        
    }


}
customElements.define("cart-drawer", CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
    constructor() {
        super();
        this.element = this;
               
        new AddToCart(this.element);

    }

}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
    }


}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this.carouselElement = this.element.querySelector("[data-swiper-settings]");
        this.delegateBody = new Delegate(document.body);
        this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
        );
        this.delegateElement = new Delegate(this.element);
        if (this.options["numberOfSlides"] > 1) {
            this.carousel = new RevolutionSwiper(this.carouselElement);
            this.onImagesReady = this.createObserver.bind(this);
            this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
            this.createObserver();
        } else {
            this.createObserver();
        }
    }

    createObserver() {
        this.observer = new IntersectionObserver(
            this.handleIntersect.bind(this),
            { threshold: 0.5 }
        )

        const target = this.element;
        this.observer.observe(target)

    }


    handleIntersect(entries) {
        var _this = this;
        entries.forEach(entry => {
            if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
                if (_this.options["numberOfSlides"] > 1) {
                    _this.changeImageQuality();
                } else {
                    _this.changeImageQuality(true);
                }
                _this.observer.unobserve(_this);
            }
        });

    }
    changeImageQuality(singleItem) {
        var breakpoint = new Responsive().getCurrentBreakpoint();

        if (singleItem == true) {
            var imageContainers = this.element.querySelectorAll(
                ".Banner__ImageContainer--Swap"
            );
        } else {
            var currentIndex = this.carousel.swiperElement.activeIndex;
            var domHelper = new DomHelper();
            var cellElement = this.carousel.swiperElement.slides[currentIndex];
            var imageContainers = domHelper.nodeListToArray(
                cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
            );
        }
        if (imageContainers.length === 0) {
            return;
        }
        var imageToReveal = null;

        if (breakpoint === "pocket" || breakpoint === "phone" || breakpoint === "tablet") {
            imageToReveal = imageContainers[0].querySelector(".Banner__Image");
        } else {
            imageToReveal = imageContainers[1].querySelector(".Banner__Image");
        }
        if (imageToReveal && imageToReveal.getAttribute('data-loaded-image') != true) {
            const replaceUrl = imageToReveal
                .getAttribute("data-src")
                .replace("{width}x", "2600x");

            imageToReveal.src = replaceUrl;
            imageToReveal.setAttribute('data-loaded-image', 'true');
        }

    }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.options = JSON.parse(this.getAttribute("data-settings"));
        this.carousel = this.element.querySelectorAll(".MenuSlideshow");
        var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");
        if (selectBoxes.length > 0) {
            selectBoxes.forEach((item, _i) => {
                new RevolutionSelectbox(
                    item
                );
            });
        }

        if (this.options.sticky) {
            this.toggleSticky();
        }
        this.bindEvents();
        this.menuOverlapHandler();
    }

    menuOverlapHandler() {
        var currentClientWidth = Math.max(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
        );

        var menuItems = this.element.querySelector('.Header--MenuItems'),
            overlapping = false,
            menuWrapper = this.element.querySelector('.HeaderWrapper'),
            allHeights = [],
            _this = this;
        if (menuItems) {
            var desiredHeight = _this.element.querySelectorAll('.mainLinks');
            desiredHeight.forEach((item, _i) => {
                allHeights.push(item.offsetHeight);
            });
            var maxHeight = Math.max.apply(null, allHeights);
            var minHeight = Math.min.apply(null, allHeights);
            if (maxHeight > minHeight) {
                overlapping = true;
                if (window.theme.menuBreakpoint == 0 || window.theme.menuBreakpoint == undefined) {
                    window.theme.menuBreakpoint = currentClientWidth;
                }

            }

        }
        if (currentClientWidth > window.theme.menuBreakpoint) {
            menuItems.classList.remove('mt-m');
            menuWrapper.querySelector('.mainMenuItems').prepend(menuItems);
            window.theme.menuBreakpoint = 0;
        } else if (overlapping) {
            menuItems.classList.add('mt-m');
            menuItems.closest('.header').appendChild(menuItems);


        }
        document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');

    }

    toggleSticky() {
        this.element.parentElement.classList.add("Header--Sticky");
        this.element.parentElement.classList.remove("Header--Transparent");
    }

    bindEvents() {
        this.toggleColorListener = this.toggleColor.bind(this);
        this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
        window.addEventListener("scroll", this.toggleColorListener);
        this.delegateElement.on(
            "mouseenter",
            ".mainMenu--Links, [aria-hasMenu]",
            this.openMenu.bind(this),
            true
        );

        this.delegateElement.on(
            "mouseleave",
            "[aria-hasMenu], [aria-singlemenu]",
            this.closeMenu.bind(this),
            true
        );

        window.addEventListener('resize', this.menuOverlapHandlerListener);
        this.delegateElement.on('focusin', '.mainMenu--Links, [aria-hasMenu]', this.openMenu.bind(this), true);
        this.delegateElement.on('focusin', '[aria-singleMenu] .mainLinks', this.closeMenu.bind(this), true);
    }

    openMenu(event, target) {
        this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
        if (event.type === "mouseenter" && target !== event.target) {
            return;
        }
        var _this = this;


        var domHelper = new DomHelper();
        _this.element.classList.remove("Header--Transparent");
        domHelper
            .nodeListToArray(target.children, '[aria-hidden="true"]')
            .forEach(function (item) {
                item.setAttribute("aria-hidden", "false");
                item.style.display = "flex";
            });
        target.setAttribute('aria-expanded', 'true');

        domHelper
            .getSiblings(target, '[aria-expanded="true"]')
            .forEach(function (item) {
                item.setAttribute('aria-expanded', 'false');
                domHelper
                    .nodeListToArray(item.children, '[aria-hidden="false"]')
                    .forEach(function (item) {
                        item.setAttribute("aria-hidden", "true");
                        setTimeout(() => { item.style.display = "none"; }, 300);

                    });
            });

    }

    closeMenu(event, target) {

        var myEvent = "";
        if (event.toElement !== undefined) {
            myEvent = event.toElement;
        } else if (event.relatedTarget !== undefined) {

            myEvent = event.relatedTarget;
        }

        if (
            (event.type === "mouseleave" && target !== event.target) ||
            myEvent.getAttribute("data-preserve") == "true"
        ) {
            return;
        }
        var _this = this;

        var domHelper = new DomHelper();
        if (_this.options['transparent']) {
            _this.element.classList.add("Header--Transparent");
        }
        if (event.type == "focusin") {

            this.element.querySelectorAll('[aria-hidden="false"]').forEach(function (item) {
                item.setAttribute("aria-hidden", "true");
                setTimeout(() => { 
                    item.style.display = "none"; 
                }, 300);
            });
        }
       
        domHelper
            .nodeListToArray(target.children, '[aria-hidden="false"]')
            .forEach(function (item) {
                item.setAttribute("aria-hidden", "true");
                setTimeout(() => { 
                    item.style.display = "none";
                 }, 300);
            });  
    }

    toggleColor() {
        let responsive = new Responsive();
        let breakpoint = responsive.getCurrentBreakpoint();

        if (this.options.transparent) {
            if (window.pageYOffset > 25 && this.options.sticky) {
                this.element.classList.remove('Header--Transparent');
            } else {
                this.element.classList.add('Header--Transparent');
            }
        }

        if (window.pageYOffset > 25) {
            this.element.classList.add('Header--SmallLogo');
            document.documentElement.style.setProperty('--header-height', this.element.clientHeight + 'px');
        } else {
            this.element.classList.remove('Header--SmallLogo');
            document.documentElement.style.setProperty('--header-height', this.element.clientHeight + 'px');
        }


    }

    
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.SidebarMenu = new Drawer(this.element);
        this.dropdown = new Dropdown(this.element);
        this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");
        var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");
        this.mainDropdown = this.element.querySelectorAll(".RevolutionDropdown--Content");

        this.mainDropdown.forEach(elem => {
            elem.classList.add('PopoverContent');
        })

        selectBoxes.forEach((item, _i) => {
            new RevolutionSelectbox(item);
        });

        this.bindEvents();
    }
    bindEvents() {
        document.addEventListener("sidebar-drawer:open", this.onDrawerListener);
    }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
    constructor() {
        this.pageOverlay = document.querySelector(".pageTransition");

        if (!this.isPageLoaded) {
            document.addEventListener(
                "DOMContentLoaded",
                this.onPageLoaded.bind(this)
            );
        } else {
            this.onPageLoaded();
        }
    }

    onPageLoaded() {
        this.isPageLoaded = true;
        if (this.pageOverlay && window.theme.showPageTransition) {
            this.pageOverlay.animate([
                { opacity: 1 },
                { opacity: 0 }
            ], {
                duration: 100,
                fill: 'forwards',
                easing: 'ease-in-out',
                iterations: 1
            })
        }
    }

    onPageUnload(event, target) {
        if (
            event.defaultPrevented ||
            event.ctrlKey ||
            event.metaKey ||
            !window.theme.showPageTransition ||
            !this.pageOverlay
        ) {
            return;
        }

        event.preventDefault(); // Prevent the click to happen

        if (this.pageOverlay) {
            var timeline = new TimelineLite({
                onComplete: function onComplete() {
                    window.location.href = target.href;
                },
            });

            timeline.fromTo(
                this.pageOverlay,
                0.25,
                { autoAlpha: 0, ease: Linear.easeNone },
                { autoAlpha: 1, ease: Linear.easeNone }
            );
        }
    }
}
var trans = new Transition();

class VideoComponent extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.options = JSON.parse(
            this.element
                .getAttribute("data-section-settings")
        );

        this.elementPosition = this.element.getAttribute('data-position');
        if (this.options['using_fade'] == "fade") {
            if (this.element.closest('.swiper-slide').classList.contains("swiper-slide-active")
                || this.element.closest('.swiper-slide').classList.contains("swiper-slide-duplicate-active")) {
                this.checkLoaded();
                this.bindEvents();
            } else {
                this.bindEvents();
            }
        } else {

            this.createObserver();
        }

    }

    bindEvents() {
        window.removeEventListener("swiper:slide-changed", this.onSlideChangeListener);
        this.onSlideChangeListener = this.onSlideChange.bind(this);
        window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);

    }

    checkLoaded() {
        var _this = this;
        if (typeof (videojs) !== 'undefined') {
            this.videoPlayerInicialization();
        } else {

            setTimeout(function () {
                _this.checkLoaded()
            }, 100)
        }
    }

    onSlideChange(event, _target) {
    let element = event.detail.element ?? event.target;
  
        if (element.getAttribute('data-id') == "productSwiperElement") {
            if (event.detail.currentIndex == this.elementPosition) {
                if (!this.element.getAttribute('loaded')) {
                    var node = document.createElement('div');
                    node.appendChild(this.element.querySelector('template').content.firstElementChild.cloneNode(true));
                    this.element.appendChild(node.firstElementChild).focus();
                    this.element.setAttribute('loaded', true);
                    if (!this.videoPlayer) {
                        this.checkLoaded();
                    } else {
                        this.videoPlayer.play();
                    }
                } else {
                    if (!this.videoPlayer) {
                        this.checkLoaded();
                    } else {
                        this.videoPlayer.play();
                    }
                }

            } else if (this.videoPlayer) {
                this.videoPlayer.pause();
            }
        }
    }


    videoPlayerInicialization() {
        var _this = this;
        if (!this.element.getAttribute('loaded')) {
            var node = document.createElement('div');
            node.appendChild(this.element.querySelector('template').content.firstElementChild.cloneNode(true));
            this.element.appendChild(node.firstElementChild).focus();
            this.element.setAttribute('loaded', true);
        }
        let responsive = new Responsive();
        let breakpoint = responsive.getCurrentBreakpoint();
        if (breakpoint == "phone" || breakpoint == "tablet") {
            var isMobile = true;
        } else {
            var isMobile = false;
        }

        let img_plh = "";
        let aspect_ratio = "";
        let src = "";
        let controls = "";
        let host = "html5";
        if (isMobile) {
            if (this.options["control_var"]) {
                src = this.options["videom"];
            } else if (this.options["video_inside_media"]) {
                src = this.options["videom"]["sources"][1]["url"];
            } else {
                src = "https://www.youtube.com/watch?v=" + this.options["videom"]["external_id"];
                host = this.options["videom"]["host"];
            }
            img_plh = this.options["plh_mob"];
            if (this.options["aspect_mob"]) {
                aspect_ratio = this.options["aspect_mob"];
            } else {
                aspect_ratio = "9:16";
            }
        } else {
            if (this.options["control_var"]) {
                src = this.options["videod"];
            } else if (this.options["video_inside_media"]) {
                src = this.options["videod"]["sources"][1]["url"];
            } else {
                src = "https://www.youtube.com/watch?v=" + this.options["videod"]["external_id"];
                host = this.options["videom"]["host"];
            }
            img_plh = this.options["plh_desk"];
            if (this.options["aspect_desk"]) {
                aspect_ratio = this.options["aspect_desk"];
            } else {
                aspect_ratio = "16:9";
            }
        }
        if (host == "youtube") {
            var type = "video/youtube";
        } else {
            var type = "video/mp4";
        }        

        const payload = {
            aspectRatio: aspect_ratio,
            autoplay: this.options["autoplay"],
            muted: this.options["muted"],
            loop: this.options["loop"],
            controls: this.options["controls"],
            poster: img_plh,
            preload: "metadata",
            playsinline: true,
            responsive: true,
            techOrder: [host],
            disablePictureInPicture: true,
            controlBar: {
                playToggle: true,
                captionsButton: false,
                chaptersButton: false,
                subtitlesButton: false,
                remainingTimeDisplay: false,
                pictureInPictureToggle: false,
                volumeControl: true,
                progressControl: {
                    seekBar: true,
                },
                fullscreenToggle: true,
                playbackRateMenuButton: false,
            },
            sources: [
                {
                    type: type,
                    src: src
                },
            ],
        };

        var videoplayerID = this.element.querySelector("video");
        this.videoPlayer = videojs(videoplayerID, payload);
        
        this.videoPlayer.on('ready', function () {
            _this.element.querySelector('.videoHolder').style.display = "block";

        });


    }
    createObserver() {
        const observer = new IntersectionObserver(
            this.handleIntersect.bind(this),
            { threshold: 0.2, rootMargin: "200px 0px 200px 0px" }
        )

        const target = this.element;
        observer.observe(target)
    }


    handleIntersect(entries) {
        entries.forEach((entry) => {
            if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
              if (!this.videoPlayer) {
                this.checkLoaded();
                return;
              }
      
              if (this.options["viewport"] && this.videoPlayer) {
                if (this.options["muted"]) {
                  this.videoPlayer.muted("true");
                }
                const checkIfPlaying = () => {
                  if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
                    this.videoPlayer.play();
                    setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
                  }
                };
      
                checkIfPlaying();
              }
            } else if (
              entry.intersectionRatio === 0 ||
              entry.isIntersecting == false
            ) {
              if (
                this.videoPlayer &&
                this.videoPlayer.el_.classList.contains("vjs-playing")
              ) {
                this.videoPlayer.pause();
              }
            }
          });
    }
}
customElements.define("video-component", VideoComponent);


class FooterComponent extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        let responsive = new Responsive();
        let breakpoint = responsive.getCurrentBreakpoint();
        if (breakpoint == "phone" || breakpoint == "tablet") {
            this.dropdown = new Dropdown(this.element);
        }


    }
}
customElements.define("footer-component", FooterComponent);

class GlobalScrollListener {
    constructor() {
      this.callbacks = new Map();
      this.listenerIdCounter = 0;
      this.isListening = false;
      this.boundRunCallbacks = this.runCallbacks.bind(this);
    }
  
    addScrollListener(classInstance, func) {
      const id = ++this.listenerIdCounter;
      const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
      const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
      const boundFunction = func.bind(classInstance);
  
      this.callbacks.set(key, boundFunction);
  
      if (!this.isListening) {
        window.addEventListener("scroll", this.boundRunCallbacks, {
          passive: true,
        });
        this.isListening = true;
      }
  
      return {
        removeScrollListener: () => this.removeScrollListenerFunction(key),
      };
    }
  
    removeScrollListenerFunction(key) {
      if (this.callbacks.has(key)) {
        this.callbacks.delete(key);
      }
  
      if (this.callbacks.size === 0 && this.isListening) {
        window.removeEventListener("scroll", this.boundRunCallbacks);
        this.isListening = false;
      }
    }
  
    runCallbacks() {
      this.callbacks.forEach((callback) => callback());
    }
  }
  
  const scrollListener = new GlobalScrollListener();



class DropdownSection extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.dropdown = new Dropdown(this.element);
    }
}
customElements.define("dropdown-section", DropdownSection);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(
      ".ProductSlider--Thumbnails"
    );
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }
    new AddToCart(this.element);
    new Dropdown(this.element.querySelector(".ProductInfo--Wrapper"));
    var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, _i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }

    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }
    if (this.options["show_thumbnails"]) {
      new RevolutionSwiper(this.element, this.carouselElementThumbs);
    }
    this.variantSelects = this.element.querySelector("variant-selects");
   
    this.stickyAtc = this.element.querySelector(".ProductPage--ATC");

  

    this.reviewsHandler();
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    this.onBsubInit = this.updateSubscriptionButton.bind(this);
    this.domDelegate.on(
      "click",
      '[data-action="open-subscription"]',
      this.openSubscription.bind(this)
    );
    this.domDelegate.on(
      "click",
      '[data-action="cancel-subscription"]',
      this.cancelSubscription.bind(this)
    );

    scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
    window.addEventListener("load", this.showStickyAtc.bind(this));
  }

  reviewsHandler() {
    var _this = this;
    var observer = new MutationObserver(function (_mutations) {
      if (_this.element.querySelector(".spr-button")) {
        _this.element.querySelector(".spr-summary-actions").style.display =
          "none";
         
        if (_this.element.querySelector("#ReviewsExist")) {
          const node = _this.element.querySelector(".reviewStatus");

          node.appendChild(
            _this.element
              .querySelector("#productReview")
              .content.firstElementChild.cloneNode(true)
          );
          const number = parseFloat(
            _this.element
              .querySelector("#productReview")
              .content.firstElementChild.getAttribute("data-value")
          );

          node.querySelector("value").innerHTML = number.toFixed(2);
          node.appendChild(
            _this.element.querySelector(".spr-summary-starrating")
          );
          _this.element.getAttribute("data-pid");
        }
        _this.element
          .querySelector(".reviewsContentEnter")
          .appendChild(_this.element.querySelector(".spr-form"));
        _this.element.querySelector(".spr-form").style.display = "block";

        const reviewTitle = _this.element.querySelector("[name='review[title]']");
        const titleValue = 'Review title';
        reviewTitle.value = titleValue.innerHTML;

        observer.disconnect();
      }
    });

    observer.observe(document, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    });
  }

  showStickyAtc() {
    const footer = document.querySelector(".footer_footer");
    const footerRect = footer.getBoundingClientRect();

    // Check if the footer is in view
    if (footerRect.top < window.innerHeight && footerRect.bottom > 0) {
        // Footer is in view, hide the button
        this.stickyAtc.setAttribute("aria-hidden", "true");
    } else {
        // Footer is out of view, show the button
        this.stickyAtc.setAttribute("aria-hidden", "false");
    }
}


  toggleInfoPopup() {
    if (new Responsive().matchesBreakpoint("pocket")) {
      this.popup = this.element.querySelector(".SubscriptionInfoPopup");
      if (this.popupOpen == false) {
        this.popup.setAttribute("aria-hidden", "false");
        this.popupOpen = true;
      } else {
        this.popupOpen = false;
        this.popup.setAttribute("aria-hidden", "true");
      }
    }
  }

  updateSubscriptionButton() {
    const url = new URL(window.location.href);
    if (url.searchParams.get("selling_plan")) {
      this.openSubscription(true);
    }
    const element = this.element
        .querySelector(".inputSelectboxCheckbox:checked")
        .closest(".SelectboxOrganic"),
      discount = document.body.querySelector(".SubscriptionButton").dataset
        .discount,
      infoElement = element.querySelector(".Selectbox--SavePrice"),
      discountPerc = discount / 100,
      productPrice = infoElement.dataset.productprice,
      variantPrice =
        infoElement.dataset.originalprice -
        infoElement.dataset.originalprice * discountPerc,
      finalPerc = Math.ceil((1 - variantPrice / productPrice) * 100);
    document.body.querySelector("#percentage").innerHTML = `${finalPerc}%`;
  }

  openSubscription(skip) {
    const button = this.element.querySelector(".SubscriptionButton");
    button.setAttribute("aria-hidden", "true");
    this.element
      .querySelector(".RevolutionDropdown--Subscription")
      .setAttribute("aria-hidden", "false");
    if (this.variantSelects) {
      this.variantSelects.setAttribute("data-subscription", "true");
    }
    const inputEL = this.element.querySelector(
      "[data-bsub-selling-plan-input]"
    );
    this.element.querySelector("#singlePack").removeAttribute("checked");

    this.element.dispatchEvent(
      new CustomEvent("bsub:changed", {
        bubbles: true,
      })
    );
    if (skip == true) {
      return;
    }
    if ("createEvent" in document) {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", false, true);
      inputEL.dispatchEvent(evt);
    } else {
      inputEL.fireEvent("onchange");
    }
  }

  cancelSubscription() {
    if (this.variantSelects) {
      this.variantSelects.setAttribute("data-subscription", "false");
    }

    this.element
      .querySelector(".SubscriptionButton")
      .setAttribute("aria-hidden", "false");
    this.element
      .querySelector(".RevolutionDropdown--Subscription")
      .setAttribute("aria-hidden", "true");
    const inputEL = this.element.querySelector('[value="once"]');
    inputEL.click();
    this.element.dispatchEvent(
      new CustomEvent("bsub:changed", {
        bubbles: true,
      })
    );
  }

  updateImage() {
    var imageID = event.detail.new_image;
    var selector = "#Image--" + imageID;
    var imageIndex = this.element
      .querySelector(selector)
      .getAttribute("data-image-position");
    this.carousel.selectCell(parseInt(imageIndex));
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(
      ".ProductSliderCell:first-child img"
    );
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.type = this.element.getAttribute('data-type');

        var selectboxes = this.element.querySelectorAll('select, input');


        selectboxes.forEach((item, _i) => {
            item.addEventListener("change", this.onVariantChange.bind(this));
        });

        this.productID = this.element.getAttribute('data-product-id');

    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton();
        this.updatePickupAvailability();

        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        if (this.element.dataset.subscription == "true" ){
            this.updateSubscriptionButton();
          }
    }


    updateOptions() {

        this.options = Array.from(
            this.querySelectorAll("select, input:checked"),
            (select) => select.value
        );




    }

    updateSubscriptionButton(){
        const source = this.element,
        element = source.querySelector('.inputSelectboxCheckbox:checked').closest('.SelectboxOrganic'),
        discount = window.theme.datadiscount_temp,
        infoElement = element.querySelector('.Selectbox--SavePrice'),
        discountPerc = discount / 100,
        productPrice = infoElement.dataset.productprice,
        variantPrice = infoElement.dataset.originalprice - (infoElement.dataset.originalprice * discountPerc),
        finalPerc = Math.ceil((1 - (variantPrice / productPrice)) * 100);
        document.body.querySelector('#percentage').innerHTML = `${finalPerc}%`;
      }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            this.options
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });

    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const newMedia = this.currentVariant.featured_media.id;
        if (!newMedia) return;
        this.element.dispatchEvent(
            new CustomEvent("variant:changed", {
                bubbles: true,
                detail: { new_image: newMedia },
            })
        );
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState(
            {},
            "",
            `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.productID}, #product-form-installment`
        );

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }

    updatePickupAvailability() {

        const pickUpAvailability = document.querySelector("pickup-availability");
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute("available");
            pickUpAvailability.innerHTML = "";
        }
    }

    renderProductInfo() {
        fetch(
            `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
        )
            .then((response) => response.text())
            .then((responseText) => {
                const id = ".ProductInfo--Prices";
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const destination = document.querySelector(id);
                const source = html.querySelector(id);

                if (source && destination) destination.innerHTML = source.innerHTML;


                this.toggleAddButton();
            });
    }

    toggleAddButton() {
        const addButton = document.querySelector(".ProductPage--ATC");
        const addButtonInner = addButton.querySelector('.SelfAlign');
        if (window.variantInfo.show_icon) {
            var buySvg =
                '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
        } else {
            var buySvg = "";
        }

        if (!addButton) return;

        if (this.currentVariant.available == false) {
            addButton.setAttribute('disabled', 'disabled');
            addButton.classList.add('ProductCard--Sold__Out');
            addButtonInner.innerHTML = buySvg + window.variantStrings.soldOut;
        } else {
            addButton.removeAttribute('disabled');
            addButton.classList.remove('ProductCard--Sold__Out');
            if (window.variantInfo.show_price) {
                var priceElement = "<span class='ml-s'>" + Shopify.formatMoney(
                    this.currentVariant.price,
                    window.theme.moneyFormat); +"</span>"
            } else { var priceElement = ""; }

            addButtonInner.innerHTML = buySvg + window.variantStrings.addToCart + priceElement;


        }

    }

    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}
customElements.define("variant-selects", VariantSelects);

class BlogSection extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.delegateRoot = new Delegate(document.body);
        this.blogWrapper = this.element.querySelector('#BlogArticleWrapper');
        this.blogElement = this.element.querySelectorAll('.BlogArticle');
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
        this.options = JSON.parse(this.element.getAttribute("data-settings"));
        if (this.options.layout == "masonary") {
            this.delegateElement.on("load", this.setupGetInspredGrid.bind(this));
        }

    }

    setupGetInspredGrid() {
        const el = this.blogWrapper;
        if (el.lengtth == 0) {
            return;
        }

        var currentClientWidth = Math.max(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
        );

        const items = this.blogElement;
        const lastItem = items[items.length - 1];
        if (items.length == 0) {
            return;
        }

        const itemWidth = lastItem.offsetWidth;
        let maxItemHeight = lastItem.offsetHeight;
        const numberOfCols = Math.floor(currentClientWidth / itemWidth);
        const numberOfRows = Math.floor(items.length / numberOfCols);

        let isSmall = false;
        let rowTemp = 0;
        let maxHeight = 0;
        items.forEach((item, i) => {
            let rowHeiht = 0;

            const element = item;
            const elementHeight = element.offsetHeight;

            const col = i % numberOfCols;
            const row = Math.floor(i / numberOfCols);

            /*calculate height of row, global max item height */
            if (row > 0) {

                for (let i = 1; i <= row; i++) {
                    const preParalelIndex = col + (i - 1) * numberOfCols;
                    const paralelEl = items[preParalelIndex];
                    rowHeiht = rowHeiht + paralelEl.offsetHeight;

                    maxItemHeight = maxItemHeight < paralelEl.offsetHeight ? paralelEl.offsetHeight : maxItemHeight;
                }

                maxHeight = maxHeight < rowHeiht ? rowHeiht : maxHeight;
            }

            /* initialize is small flag for that row */
            if (row !== rowTemp) {
                rowTemp = row;

                isSmall = row % 2 != 0;
            }

            const left = col * itemWidth;

            const top = rowHeiht.toFixed(2);

            if (top !== 'NaN') {

                const isHidden = false; //row > numberOfRows-2 && col%2 == 0; //hidden last two blog posts, owerflow problem

                if (!isHidden) {
                    const padding = isSmall ? `${90 + Math.random() * 20}%` : `${110 + Math.random() * 40}%`;


                    item.querySelector('.BlogItem--Wrapper').style.paddingTop = padding + "px";

                    const myitem = item;
                    myitem.style.cssText = "left:" + left + "px;top:" + top + "px";

                    isSmall = !isSmall;
                }
            }
        });

        var elHeight = parseInt(maxHeight) + parseInt(maxItemHeight);
        el.style.cssText = "width:" + numberOfCols * itemWidth + "px;height:" + elHeight + "px;margin:auto";

    }

}
customElements.define("blog-section", BlogSection);

class SearchBar extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.searchElement = this;
      this.delegateElement = new Delegate(this.element);
      this.delegateBody = new Delegate(document.body);
      this.searchInputElement = this.element.querySelector('[name="q"]');
      this.queryMap = {};
      this.searchResultsElement = this.element.querySelector(".SearchInitial");
      this.pageOverlayElement = document.querySelector(".pageOverlay");
      this.options = JSON.parse(this.element.getAttribute("data-settings"));
      this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
      if (window.theme.showRecentSearches) {
        this.getRecentSearches();
      }
      if (window.theme.showSuggestedSearches) {
        this.getSuggestedSearches();
      }
      this.carouselElement = this.element.querySelector(".SearchCollection");
      if (this.carouselElement) {
        if (new Responsive().matchesBreakpoint("lap-and-up")) {
          this.carousel = new RevolutionSwiper(this.carouselElement);
        }
      }
      if (window.theme.enableImageAnimations) {
        new RevolutionAnimation(this.element);
      }

      new AddToCart(this.element);
      this.bindEvents();
    }
  
  
    bindEvents() {
      this._preventSubmissionListener = this.preventSubmission.bind(this);
      this._onInputListener = this.debounce(this.onInput.bind(this), 450);
  
      this.delegateElement.on(
        "click",
        '[data-action="open-search"]',
        this.openSearch.bind(this)
      );
      this.delegateElement.on(
        "click",
        '[data-action="close-search"]',
        this.closeSearch.bind(this)
      );
      this.searchInputElement.addEventListener(
        "keydown",
        this._preventSubmissionListener
      );
      this.searchInputElement.addEventListener("input", this._onInputListener);
      this.delegateElement.on(
        "click",
        '[data-action="search-string"]',
        this.onInput.bind(this)
      );

      this.delegateBody.on("close:search", this.closeSearch.bind(this));
      this.delegateElement.on("click",'[data-action="clear-search"]',this.clearSearch.bind(this));
    }

    clearSearch(event) {
        const wrapper = event.target.closest(".SearchHeader");
        const input = wrapper.querySelector(".SearchInput");

        if (!input) return;

        input.value = "";
        input.focus();
        event.target.setAttribute("aria-hidden", "true");
        this.onInput(event, input);
    }
  
    initCarousel() {
      if (new Responsive().matchesBreakpoint("lap-and-up")) {
        var carousel = this.searchResultsElement.querySelector(
          "[data-swiper-settings]"
        );
        if (carousel) {
          this.newCarousel = new RevolutionSwiper(carousel);
        }
      }
    }
  
    debounce(fn, delay) {
      var _this0 = this;
  
      var timer = null;
  
      return function () {
        for (
          var _len = arguments.length, args = Array(_len), _key = 0;
          _key < _len;
          _key++
        ) {
          args[_key] = arguments[_key];
        }
  
        clearTimeout(timer);
  
        timer = setTimeout(function () {
          fn.apply(_this0, args);
        }, delay);
      };
    }
  
    openSearch() {
      event.preventDefault();

      if (this.isOpen) return this.closeSearch();

      const header = document.querySelector("header-component");
      document.documentElement.style.setProperty('--header-height', header.clientHeight + 'px');
      
      var target = event.target;

      if (!this.searchElement.querySelector(".SearchSlide ") && this.options["product"] && this.options["collection"] == "") {
        this.loadRecommendations();
      }
  
      target.parentElement.querySelector(".SearchWrapper").setAttribute("aria-hidden", false);

      this.pageOverlayElement.classList.add("is-visible");
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";

      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);

      Utility.bodyScrollLockDisable(this.searchElement);

      this.isOpen = true;
      this.searchElement.querySelector(".SearchInput").focus();
      document.body.querySelector("#shopify-section-header").style.zIndex = "99 !mportant";

      if (this.options["transparent"]) {
        setTimeout(() => {
          document.body
            .querySelector("#header")
            .classList.remove("Header--Transparent");
        }, 15);
      }
    }
  
    closeSearch() {
      event.preventDefault();
      var _this = this;
      if (!this.isOpen) {
        return;
      }
    
      Utility.bodyScrollLockClear();
      //document.body.querySelector("#shopify-section-header").style.zIndex = "3";
      document.body.querySelectorAll(".SearchWrapper").forEach((item, _i) => {
        item.setAttribute("aria-hidden", true);
      });

      _this.pageOverlayElement.classList.remove("is-visible");
      document.body.querySelector(
        "#shopify-section-header"
      ).style.backgroundColor = "transparent";

      document.body.style.overflow = "unset";
      document.body.style.width = "100%";
      if (_this.options["transparent"]) {
        document.body
          .querySelector("#header")
          .classList.add("Header--Transparent");
      }
      this.resetSearch();
      this.isOpen = false;
    }
  
    preventSubmission(event) {
      if (event.keyCode === 13 && window.theme.searchMode !== "product") {
        event.preventDefault();
      }
    }
  
    onInput(event, target) {
      target = target || event.target;

      this.lastInputValue = target.value;
      var passTrough = false;
      var _this = this;
      this.searchResultsElement.style.opacity = 0;
      if (target.getAttribute("value") && _this.lastInputValue === 0) {
        this.lastInputValue = target.getAttribute("value");
        const el = _this.searchElement.querySelector(".SearchInput");
        passTrough = true;
        el.setAttribute("value", _this.lastInputValue);
        el.value = _this.lastInputValue;
      } else {
        if (event.keyCode === 13) {
          return;
        }
  
        if (this.lastInputValue === "") {
          this.initialSearchLayout.style.opacity = 0;
          this.resetSearch();
          return;
        }
      }
  
      var queryOptions = {
        method: "GET",
        credentials: "same-origin",
      };
      const url = `${window.routes.localeRootUrl}/search?view=ajax&q=${encodeURIComponent(this.lastInputValue)}*&type=product`;
      var queries = [
        fetch(
          url,
          queryOptions
        ),
      ];
  
      if (_this.options["suggestedCollections"]) {
        const url = `${window.routes.localeRootUrl}/search/suggest.json?q=${encodeURIComponent(this.lastInputValue)}&resources[type]=collection&resources[limit]=1`;
        queries.push(
          fetch(
            url,
            queryOptions
          )
        );
      }
  
      if (window.theme.searchMode !== "product") {
        const url = `${window.routes.localeRootUrl}/search?view=ajax&q=${encodeURIComponent(this.lastInputValue)}*&type=${window.theme.searchMode.replace("product,", "")}`;
        queries.push(
          fetch(
            url,
            queryOptions
          )
        );
      }
  
  
      this.queryMap[this.lastInputValue] = true;
  
      Promise.all(queries).then(function (responses) {
        if (_this.lastInputValue !== event.target.value && passTrough == false) {
          return;
        }
        delete _this.queryMap[event.target.value];
  
        Promise.all(
          responses.map(function (response) {
          return response.text();
          })).then(function (contents) {
         
          //resultExists determines if there is any other results like products, articles or pages
  
          var resultExistsObject = [],
            resultExists,
            collectionHTML = document.createElement('div');
            
            contents.forEach((item, i) => {
              if (item.includes('collections')){
                let collectionInner = '',
                      collectionObject = JSON.parse(item);
                if(collectionObject.resources.results.collections.length > 0){
                  collectionHTML.innerHTML = _this.layouts( _this.lastInputValue,false,false,'collectionLayout');
                  resultExistsObject.push(true);
                      collectionObject.resources.results.collections.forEach(function (entry) {
                      collectionInner += _this.layouts(entry.url, entry.featured_image.url, entry.title, 'collectionItem');
                    });
                    collectionHTML.querySelector('.Segment__Content').innerHTML = collectionInner;
                }else{
                  resultExistsObject.push(false);
                  collectionHTML.innerHTML = _this.layouts(false, false, false, 'collectionItemNoResults');
                }
                      
                contents[i] = collectionHTML.innerHTML;
  
              }else{
                if(item.includes('js-noresult')){
                  resultExistsObject.push(false);
                }else{
                  resultExistsObject.push(true);
                }
  
              }
            });
  
  
  
            
            if(resultExistsObject.includes(true)){
              resultExists = true;
            }else{
              resultExists = false;
            }
        
            if (window.theme.showRecentSearches) {
              _this.recentSearches();
            }
        
          _this.loadData(window.theme.searchMode, resultExists, contents);
      
            const clearSearchButton = _this.element.querySelector(".search__clear-search");
            if (target.value !== "") clearSearchButton?.setAttribute("aria-hidden", "false");
            else clearSearchButton?.setAttribute("aria-hidden", "true");
        });
      });
    }
  
    loadData(_searchMode, resultExists, data){
  
      const _this = this;
      switch(resultExists){
  
        case true:
        let content = "";
        
        data.forEach((item) => {
         content += item; 
        });
        this.searchResultsElement.innerHTML = 
        `<div class='SearchLayout--${data.length}items'>${content}</div>`
        break;
  
        case false:
          let tempElement = document.createElement("div");
              tempElement.innerHTML = data[0];
              tempElement = tempElement.querySelector("#noResultAll");
  
  
          if (this.options["noResultcollection"]) {
            this.searchResultsElement.innerHTML = this.layouts(tempElement.innerHTML, false, false, 'noResults');
  
          } else {
            this.searchResultsElement.innerHTML = this.layouts(tempElement.innerHTML, false, false, 'noResultsNoSuggestions');
          
          }
        break;
      }
  
  
      if (window.theme.enableImageAnimations) {
        new RevolutionAnimation(_this.searchResultsElement);
      }
      _this.searchResultsElement.setAttribute("aria-hidden", "false");
      _this.initCarousel();
      _this.searchResultsElement.style.opacity = 1;
      new AddToCart(_this.element);
  
    }
  
    layouts(string1, string2, string3, type){
      var template = '';
      switch(type){
  
        case 'collectionLayout':
          template = 
          `<div class='SearchLayout__Section--collections' data-animation="elementFromBottom">
            <div class='SearchSegmentHeader'>
              <span class=' u-h5'>${window.languages.collections}</span>
              <a class='u-p5 underline SearchHeader--Primary hoverLinks' href='/search?q=${string1}*&amp;type=product'>${window.languages.view_all}</a>
            </div>
            <div class='Segment__Content'></div>
          </div>`;
        break;
  
          case 'collectionItem': 
          template = 
          `<a href='${string1}' class='CollectionSearchItem SearchSlide animatedContent' style='padding-bottom: 80%'>
            <img src='${string2}' class='SearchCollectionImage'>
              <div class='SearchCollectionContent'>
                <h5 class='u-h3 mb-s'>${string3}</h5>
              </div>
          </a>`;
          break;
  
          case 'collectionItemNoResults':
          template = 
          `<div class='searchSegment'>
            <div class="SearchSegmentHeader">
              <span class=" u-h5">${window.languages.collections}</span>
            </div>
            <div class="Segment__Content">
              <p class="SegmentNoResult u-p5">${window.languages.no_results}</p>
            </div>
          </div>`;
          break;
  
          case 'noResults':
          template = 
          `<div class="SearchLayout__Section Search--Recommendations-noResults">${string1}</div>\n`;
          break;
  
      }
       
  
      return template;
    }
  
  
    loadRecommendations() {
      var _this = this,
        product_to_search = _this.options["product"],
        url =
          window.routes.localeRootUrl +
          "/recommendations/products?section_id=search_suggested&product_id=" +
          product_to_search +
          "&limit=8";
  
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement("div");
          var contentjq = document.createElement("div");
          contentjq.innerHTML = content;
          container.innerHTML = contentjq.innerHTML;
          const newSwiper = _this.element.querySelector(
            ".SearchInitial--Products"
          );
          newSwiper.innerHTML = container.querySelector(
            ".ProductRecommendations"
          ).innerHTML;
          _this.initCarousel();
    
          if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(newSwiper);
          }
          new AddToCart(_this.element);
        });
      });
    }
    resetSearch() {
      this.initialSearchLayout.querySelector(
        ".SearchInitial--Recents"
      ).style.opacity = 0;
      if (this.initialSearchLayout.querySelector(".SearchInitial--Products")) {
        this.initialSearchLayout.querySelector(
          ".SearchInitial--Products"
        ).style.opacity = 0;
      }
  
      this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
  
      const el = this.searchElement.querySelector(".Search__Form");
      el.value = "";
      el.removeAttribute("value");
      const elInput = this.searchElement.querySelector(".SearchInput");
      elInput.value = "";
      this.searchResultsElement.setAttribute("aria-hidden", "false");
      if (window.theme.showRecentSearches) {
        this.getRecentSearches();
      }
      if (window.theme.showSuggestedSearches) {
        this.getSuggestedSearches();
      }
      if (this.options["product"] && this.options["collection"] == "") {
        this.loadRecommendations();
      }

     this.widgetElement = this.element.querySelectorAll('[data-oke-star-rating]');
      this.widgetElement.forEach((item) => {
          window.okeWidgetApi.initWidget(item);
      });

      if (window.theme.enableImageAnimations) {
        new RevolutionAnimation(this.element);
      }
      this.element.querySelector(".SearchInitial").style.display = "flex";
      this.initCarousel();
      this.searchResultsElement.style.opacity = 1;
      this.searchResultsElement.querySelector(
        ".SearchInitial--Recents"
      ).style.opacity = 1;
      this.searchResultsElement.querySelector(
        ".SearchInitial--Products"
      ).style.opacity = 1;
    }

  
    recentSearches() {
      this.searchResultsElement.style.opacity = 0;
  
  
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
  
      if (this.lastInputValue.length > 3) {
        var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
        if (!searchTerm.includes(this.lastInputValue)) {
          searchTerm.unshift(this.lastInputValue);
        }
  
        // Then, we save the search info into the local storage, by keeping only the 5 most recent
        try {
          localStorage.setItem(
            "searchTerms",
            JSON.stringify(searchTerm.slice(0, 5))
          );
        } catch (error) {}
      }
    }
  
    getRecentSearches() {
      var appendString = "";
      var items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      var appElement = this.searchElement.querySelector(
        ".Search--Recent__results"
      );
      if (items.length > 0) {
        items.forEach((id, _index) => {
          appendString =
            appendString +
            "<li tabIndex='0' data-action='search-string' value='" +
            id +
            "'>" +
            id +
            "</li>";
        });
  
        appElement.innerHTML = appendString;
      } else {
        var appEl = this.searchElement.querySelector(".Search--Recent");
        appEl.style.display = "none";
      }
    }
    getSuggestedSearches() {
      var appendString = "";
      const arr = this.options.items;
      arr.sort(function () {
        return 0.5 - Math.random();
      });
      var filtred = arr.filter(function (a) {
        if (!a.includes("_")) {
          return a;
        }
      });
  
      var i;
      appendString = "";
      for (i = 0; i < 5; i++) {
        if (filtred[i]) {
          var filteredResult = filtred[i].replace(":", " ");
          filteredResult = filteredResult.replace("-", " ");
          appendString =
            appendString +
            "<li tabindex='0' data-action='search-string' value='" +
            filteredResult +
            "'>" +
            filteredResult +
            "</li>";
        }
      }
      var appElement = this.searchElement.querySelector(
        ".Search--Suggested__results"
      );
      appElement.innerHTML = appendString;
    }
  }
  customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.bindEvents();
        this.toggleButton();
    }
    bindEvents() {
        this.delegateElement.on(
            "change",
            "[data-state='required']",
            this.toggleButton.bind(this)
        );
    }

    toggleButton() {
        this.buttonState = true;

        var allBoxes = this.element.querySelectorAll("[data-state='required']");
        allBoxes.forEach((item, _i) => {
            if (item.checked == false) {
                this.buttonState = false;
            }
        });
        if (this.buttonState == true) {
            this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
        } else {
            this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
        }
    }
}

customElements.define("contact-section", ContactSection);

class InfiniteScroll {
    constructor(container, restoreState) {
        this.containerSelector = container;
        this.treshold = 650;
        this.handleScrollListener = this.handleScroll.bind(this);
        this.currentPage = 1; 
        
        if (restoreState === true && sessionStorage.getItem('pageState')) {
          const promises = this.generateFetchPromises(false);
          this.renderData(promises, true);
        } else {
          this.initialize();
        }

        document.addEventListener('click', (event) => {
            if (event.target.closest('.cardWrapper--Link')) {
              const scrollPosition = window.scrollY;
              sessionStorage.setItem('scrollPosition', scrollPosition);
              sessionStorage.setItem('currentPage', this.currentPage);
            }
          });
    
        window.addEventListener('popstate', () => {
          this.reinitialize();
        });
    
      }
    
      initialize() {
        document.addEventListener('scroll', this.handleScrollListener);
    
        const scrollPosition = sessionStorage.getItem('scrollPosition');
        const currentPage = sessionStorage.getItem('currentPage');
        
        if (scrollPosition !== null && currentPage !== null) {
          this.currentPage = parseInt(currentPage, 10);
          window.scrollTo(0, parseInt(scrollPosition, 10));
          sessionStorage.removeItem('scrollPosition');
          sessionStorage.removeItem('currentPage');
          this.restoreStatePages(this.currentPage);
        }
    
      }
    
      reinitialize() {
        this.initialize();
      }
    
      restoreStatePages(currentPage) {
        const promises = this.generateFetchPromises(false, currentPage);
        this.renderData(promises, true);
      }
  
    handleScroll() {
      this.paginationElement = document.querySelector('#infiniteScroll');
      if (!this.paginationElement) return;
        const top = this.paginationElement.getBoundingClientRect().top - this.treshold;
    
        const bottom = this.paginationElement.getBoundingClientRect().bottom + this.treshold;
        
        if (top <= window.innerHeight && bottom >= 0) {
            this.nextPageLinkElement = this.paginationElement.querySelector('a');
            
            if (this.nextPageLinkElement) {
                this.destroy();
                const nextPageUrl = this.nextPageLinkElement.href;
            
                const promises = this.generateFetchPromises(nextPageUrl);
                this.renderData(promises);
            }
        }
    }
  
    destroy() {
      // Remove the event listener when the instance is no longer needed
      document.removeEventListener('scroll', this.handleScrollListener);
    }
  
      generateFetchPromises(nextPageUrl, restorePage) {
        const promises = [];
        const limit = restorePage || this.currentPage;
  
        if(!nextPageUrl){
          const hasSearchParameters = window.location.search.length > 0;
       
          for (let i = 2; i <= limit; i++) {
            let url;
        
            // Build the URL based on the condition
            if (hasSearchParameters) {
              url = `${window.location.href}&page=${i}`;
            } else {
              url = `${window.location.href}?page=${i}`;
            }
  
            promises.push(fetch(url, {
              credentials: "same-origin",
              method: "GET",
            }));
          }
        } else {
          //const url = `${nextPageUrl}`;
    
          promises.push(fetch(nextPageUrl, {
            credentials: "same-origin",
            method: "GET",
          }));
          this.currentPage++;
        }
  
        return promises;
      }
    
  
    async renderData(promises, restoreContent) {
      try {
        const responses = await Promise.all(promises);
        const contents = await Promise.all(responses.map(response => response.text()));
        let isLastPromise = false;
        contents.forEach((content, index) => {
        
            isLastPromise = index === contents.length - 1;
         
            this.appendContent(content, isLastPromise, restoreContent);
        });
      } catch (error) {
        console.error('Error fetching or parsing data:', error);
      }
    }
  
  
    appendContent(content, lastPromise, restoreContent){
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      const contentToAdd = doc.querySelector(this.containerSelector);
    
  
      this.mainContainer = document.querySelector(this.containerSelector);
      this.paginationElement = document.querySelector('#infiniteScroll');
      if (this.paginationElement){
        this.paginationElement.remove();
      }
  
      this.mainContainer.insertAdjacentHTML('beforeend', contentToAdd.innerHTML);
      this.paginationElement = document.querySelector('#infiniteScroll');
      if(lastPromise){
        this.initialize();
      }
  
      if(lastPromise && restoreContent){
        this.restoreScroll();
      }
  
      document.dispatchEvent(
        new CustomEvent("pagination:finished", { bubbles: true })
      );
   
    }
    restoreScroll() {
      const selector = `${this.containerSelector} [data-id='${sessionStorage.getItem('pageStateProduct')}']`;
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth', // You can use 'auto' for instant scrolling
          block: 'start',     // You can use 'center' or 'end' for different alignments
        });
      }
    }
  }
  
class CollectionGrid extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
        new AddToCart(this.element);

        this.bindEvents();

        // document.addEventListener("DOMContentLoaded", function() {
        //     var endlessScroll = new Ajaxinate({
        //       container: '#mainCollectionHolder',
        //       pagination: '#collectionPagination'
        //     });
        //   });

        if( window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD || window.performance && window.performance.navigation.type === 1){
            new InfiniteScroll('#mainCollectionHolder');
            // if ('scrollRestoration' in history) {
            //   history.scrollRestoration = 'manual';
            // }
            
          } else {
      
            new InfiniteScroll('#mainCollectionHolder');
            sessionStorage.removeItem('pageState');
            sessionStorage.removeItem('pageStateProduct');
          }

    }

    bindEvents() {
        this.delegateElement.on(
          'click',
          '[data-action="mobile-tap"]',
          this.setLastClick.bind(this)
        );
    }

    setLastClick(event){
        let dataPage = event.target.dataset.page;
        let dataPageProduct = event.target.dataset.id;
        if(!event.target.dataset.page){
          dataPage = event.target.closest('[data-page]').dataset.page;
          dataPageProduct = event.target.closest('[data-page]').dataset.id;
        }
        sessionStorage.setItem('pageState', dataPage);
        sessionStorage.setItem('pageStateProduct', dataPageProduct);
    }
}
customElements.define("collection-grid", CollectionGrid);

class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            input: this.querySelector('input[name="language_code"], input[name="country_code"]')
        };
        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }


    onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
    }

}

customElements.define('localization-form', LocalizationForm);


class PickupAvailability extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        if (!this.hasAttribute('available')) return;
        this.fetchAvailability(this.dataset.variantId);

    }

    fetchAvailability(variantId) {
        const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=pickup`;

        fetch(variantSectionUrl)
            .then(response => response.text())
            .then(text => {
                const sectionInnerHTML = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('.shopify-section');
                this.renderPreview(sectionInnerHTML);
            })
            .catch(_e => {
                this.renderError();
            });
    }

    renderError() {


    }

    renderPreview(sectionInnerHTML) {

        this.element.innerHTML = '';

        this.element.appendChild(sectionInnerHTML.querySelector('.LocalPickup__Wrapper'));
        if (sectionInnerHTML.querySelector('#LocalPickup')) {
            this.element.appendChild(sectionInnerHTML.querySelector('#LocalPickup'));
            new Drawer(this.element.querySelector('#LocalPickup'));
        }


    }
}

customElements.define('pickup-availability', PickupAvailability);

class CartNote extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.textarea = this.element.querySelector('textarea');
        this.button = this.element.querySelector('.CartNote--Submit');
        this.noteSucess = this.element.querySelector('.cartNote--Success');
        this.bindEvents();
    }
    bindEvents() {


        this.delegateElement.on(
            "click",
            "[data-action='update-note']",
            this.updateNote.bind(this)
        );

        this.delegateElement.on(
            "click",
            "[data-action='edit-note']",
            this.editNote.bind(this)
        );



    }
    editNote() {
        this.textarea.removeAttribute('disabled');
        this.button.innerText = window.cartStrings.enter_note;
        this.button.setAttribute('data-action', 'update-note');
        this.noteSucess.style.visibility = "hidden";

    }

    updateNote() {
        var _this = this;
        this.value = this.textarea.value;

        fetch(window.routes.localeRootUrl + "/cart/update.js", {
            body: JSON.stringify({ note: this.value }),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            }
        }).then(function (response) {
            if (response.ok) {
                if (_this.value == "") {
                    return;
                }
                _this.textarea.setAttribute('disabled', 'disabled');
                _this.button.innerText = window.cartStrings.note_change;
                _this.button.setAttribute('data-action', 'edit-note');
                _this.noteSucess.style.visibility = "visible";
            }
        });

    }
}

customElements.define('cart-note', CartNote);

class AnimationWrapper extends HTMLElement {
    constructor() {
        super();
        this.element = this;

        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
    }
}
customElements.define("animation-wrapper", AnimationWrapper);

class NewsletterPopup extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
        this.handleOpenOptions();
        if (this.options.edit_mode == true) {
            this.options.delay = 0;
            this.openNewsletter();
        }

    }

    handleOpenOptions() {
        let sessionKey = sessionStorage.getItem('popup-seen');
        var localKey = localStorage.getItem('popup-seen');
        if (this.options.show_only_once == true && localKey == "true") {
            return;
        }
        if (sessionKey != "true") {
            if (this.options.scroll_amount > 0) {
                this.scrollListener = this.scrollListener.bind(this);
                document.addEventListener('scroll', this.scrollListener);

            } else {
                this.openNewsletter();
            }

        }
    }


    scrollListener() {
        var _this = this,
            body = document.body,
            html = document.documentElement;
        let docHeight = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);
        let percScrolled = window.scrollY / docHeight * 100;
        if (percScrolled >= _this.options.scroll_amount) {
            _this.openNewsletter();
        }
    }

    openNewsletter() {
        var _this = this;
        setTimeout(() => {
            this.element.setAttribute('aria-hidden', false);
            this.pageOverlayElement.classList.add("is-visible");
            Utility.bodyScrollLockDisable(this.element);

            this.onClickOutsideListener = this.closeNewsletter.bind(this);
            this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);
            sessionStorage.setItem('popup-seen', true);
            localStorage.setItem('popup-seen', true);
            this.delegateElement.on(
                "click",
                '[data-action="close-modal"]',
                this.closeNewsletter.bind(this)
            );
        }, 1000 * _this.options.delay);
    }

    closeNewsletter() {
        this.element.setAttribute('aria-hidden', true);
        this.pageOverlayElement.classList.remove("is-visible");
        Utility.bodyScrollLockClear();
        this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
        document.removeEventListener('scroll', this.scrollListener);
    }
}

customElements.define("newsletter-popup", NewsletterPopup);

class SwiperAll extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      new RevolutionSwiper(this.element.querySelector(".swiper"));

      const atcNeeded = 
        this.element.querySelector("[data-action=add-to-cart]") || this.element.querySelector('form[action="/cart/addall"]') || this.element.querySelector("[data-action=add-all-to-cart]");

      if (atcNeeded) new AddToCart(this.element);
    }
}

customElements.define("swiper-wrapper", SwiperAll);

class MobileSwiper extends HTMLElement {
    constructor() {
            super();
            let responsive = new Responsive();
            let breakpoint = responsive.getCurrentBreakpoint();
            this.element = this;
            if (breakpoint == "phone" || breakpoint == "tablet") {
                this.options = JSON.parse(this.getAttribute("data-settings"));
                new RevolutionSwiper(this.element.querySelector(".swiper"));
            }
    }
}
customElements.define("mobile-swiper", MobileSwiper);

class Specification extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.newSpec = this.element.parentElement;
    this.delegateElement = new Delegate(this.element);

    this.specBtn = this.element.querySelector('#spec-title');
var _this = this;
   window.onload = function () {
  _this.maxHeight();
 }
    this.bindEvents();

  }
  bindEvents(){
    this.delegateElement.on('click', '[data-action="toggle-specification"]', this.showSpecification.bind(this));

  }
  showSpecification(_event, target){


   const id = target.getAttribute('data-id');

   this.element.querySelectorAll('.specification-data').forEach((item,_i) => {
    item.classList.add('hidden');
  });

   this.element.querySelector('#'+ id).classList.remove('hidden');

   this.element.querySelectorAll('#spec-title').forEach((item,_i) => {
    item.classList.remove('active');
  });
  target.classList.add('active');

  }

  maxHeight(){
    var _this = this;
    var observer = new MutationObserver(function(_mutations) {
       if (_this.element.querySelector('.specification-data')) {


             var allSpec = _this.element.querySelectorAll('.specification-data');
             var t=0; // the height of the highest element (after the function runs)
             var t_elem;  // the highest element (after the function runs)
             var allNumbers = [];
             allSpec.forEach((item, _i) => {
            allNumbers.push(item.scrollHeight);
             });

    var t = Math.max.apply(Math, allNumbers);

             

            observer.disconnect();


        }
    });

    observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});


  }

}

customElements.define("tabs-section", Specification);

class beforeAfter extends HTMLElement {
    constructor() {
            super();
           
            this.element = this;

            const slider = document.querySelector(".beforeAfter--container");
            const sliderImgWrapper = document.querySelector(".after--image");
            const sliderHandle = document.querySelector("#myRange");
           

            slider.addEventListener("mousemove", sliderMouseMove);
            slider.addEventListener("touchmove", sliderMouseMove);

            function sliderMouseMove(event) {

                if(isSliderLocked) return;

                const sliderLeftX = slider.offsetLeft;
                const sliderWidth = slider.clientWidth;
                const sliderHandleWidth = sliderHandle.clientWidth;

                let mouseX = (event.clientX || event.touches[0].clientX) - sliderLeftX;
                if(mouseX < 0) mouseX = 0;
                else if(mouseX > sliderWidth) mouseX = sliderWidth;

                sliderImgWrapper.style.width = `${((1 - mouseX/sliderWidth) * 100).toFixed(4)}%`;
                
                sliderHandle.style.left = `calc(${((mouseX/sliderWidth) * 100).toFixed(4)}% - ${sliderHandleWidth/2}px)`;
                
                }

                let isSliderLocked = false;

                slider.addEventListener("mousedown", sliderMouseDown);
                slider.addEventListener("touchstart", sliderMouseDown);
                slider.addEventListener("mouseup", sliderMouseUp);
                slider.addEventListener("touchend", sliderMouseUp);
                slider.addEventListener("mouseleave", sliderMouseLeave);

                function sliderMouseDown(event) {
                if(isSliderLocked) isSliderLocked = false;
                sliderMouseMove(event);
                }

                function sliderMouseUp() {
                if(!isSliderLocked) isSliderLocked = true;
                }

                function sliderMouseLeave() {
                if(isSliderLocked) isSliderLocked = false;
                }
                                    
    }
}
customElements.define("before-after", beforeAfter);

class InstagramSection extends HTMLElement {
    constructor() {
      super();
      this.element = this;
        var images = new Array();
        var boxes = new Array();
    this.delegateElement = new Delegate(this.element);
    var _this = this;
    var observer = new MutationObserver(function(_mutations) {
       if (_this.element.querySelector('.instafeed-container')) {
        var allElements = _this.element.querySelectorAll('.instafeed-container');

        allElements.forEach((item, _i) => {

          const img = item.querySelector('img');
          if(img){
                images.push(img.getAttribute('data-src'));
          }

        });
            observer.disconnect();
            _this.element.querySelectorAll('.InstagramImageWrapper').forEach((item, i) => {
              item.querySelector('img').setAttribute('src', images[i]);

            });

        }
    });

    observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});

    }
    cleanSelector(selector){
      (selector.match(/(#[0-9][^\s:,]*)/g) || []).forEach(function(n){
          selector = selector.replace(n, '[id="' + n.replace("#", "") + '"]');
      });
      return selector;
    }


  }

  customElements.define("instagram-section", InstagramSection);


  class SearchFaq extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
       
        this.searchBar = this.element.querySelector('#searchBar');

        this.bindEvents();


    }
    bindEvents() {
     
        this.delegateElement.on('keyup', '[data-action="searchItem"]', this.search.bind(this));
        
    }

    search() {
        
        let input = document.getElementById('searchBar').value;
        input = input.toLowerCase();
        

        var searchableItems = document.querySelectorAll('.Dropdown');

        
        var i = 0;

        for (i = 0; i < searchableItems.length; i++) {
            if (!searchableItems[i].innerHTML.toLowerCase().includes(input)) {
                searchableItems[i].style.display = "none";
            } else {
                searchableItems[i].style.display = "block";
            }
        }
    }


}
customElements.define("search-faq", SearchFaq);


class MapDrawer extends HTMLElement{
    constructor(){
        super();
        this.element = this;
      new Drawer(this.element);
      this.delegateElement = new Delegate(this.element);

      }



}
customElements.define("map-drawer", MapDrawer);


class MobileMap extends HTMLElement{
    constructor(){
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
      this.dropdown = new Dropdown(this.element);

      this.bindEvents();
      }
      bindEvents() {
      this.delegateElement.on(
          "click",
          '[data-action="change-country"]',
          this.changeCountry.bind(this)
      );
    }

    changeCountry(){
      var id = event.target.getAttribute('aria-id');

      var element = document.body.querySelector('#' + id);
        this.dropdown.closeDropdown(document.body.querySelector('.CountryToggler'));

      new DomHelper().getSiblings(element, ".mapDrawer--Items", true).forEach(function (item) {

          item.style.display = "none";
      });
          element.style.display = "block";
    }

}
customElements.define("mobile-map", MobileMap);

class MapHolder extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.pos = { top: 0, left: 0, x: 0, y: 0 };
        this.mapContainer = this.element.querySelector('.mapWrapper');
            this.bindEvents();
    }
    
        bindEvents(){
          this.zoomListener = this.zoomMap.bind(this);
          this.delegateElement.on(
              "click",
              '[data-action="expand-map"]',
              this.zoomListener
          );
          this.delegateElement.on(
              "click",
              '.dots',
              this.openDrawer.bind(this)
          );
          this.mapContainer.addEventListener('mousedown', this.mouseDownHandler.bind(this));
    
        }
    
        zoomMap(){
          if (this.mapContainer.classList.contains('fixedMap')){
            this.mapContainer.classList.remove('fixedMap');
              this.element.querySelector('.mapOverlay').classList.remove('is-visible');
              this.element.querySelector('.mapOverlay').removeEventListener('click', this.zoomListener);

              Utility.bodyScrollLockEnable(this.mapContainer);
              this.element.querySelector('.closeMap').classList.remove('is-visible');
          }else{
              this.element.querySelector('.mapOverlay').classList.add('is-visible');
            this.mapContainer.classList.add('fixedMap');
              this.element.querySelector('.closeMap').classList.add('is-visible');

            Utility.bodyScrollLockDisable(this.mapContainer);
            this.element.querySelector('.mapOverlay').addEventListener('click', this.zoomListener);
          }
    
        }
    
    
        mouseDownHandler(event){
          this.mapContainer.style.cursor = 'grabbing';
          this.mapContainer.style.userSelect = 'none';
          this.pos = {
           // The current scroll
           left: this.mapContainer.scrollLeft,
           top: this.mapContainer.scrollTop,
           // Get the current mouse position
           x: event.clientX,
           y: event.clientY,
       };
       this.mouseMoveListener = this.mouseMoveHandler.bind(this);
       this.mouseUpListener = this.mouseUpHandler.bind(this);
       document.addEventListener('mousemove', this.mouseMoveListener);
       document.addEventListener('mouseup', this.mouseUpListener);
        }
    
        mouseUpHandler(_event){
          document.removeEventListener('mousemove', this.mouseMoveListener);
    document.removeEventListener('mouseup', this.mouseUpListener);
    
    this.mapContainer.style.cursor = 'grab';
    this.mapContainer.style.removeProperty('user-select');
    
        }
    
        mouseMoveHandler(event){
          const dx = event.clientX - this.pos.x;
          const dy = event.clientY - this.pos.y;
    
     // Scroll the element
     this.mapContainer.scrollTop = this.pos.top - dy;
     this.mapContainer.scrollLeft = this.pos.left - dx;
        }
    
      openDrawer(){
        const drawer = document.body.querySelector(`[data-country=${event.target.getAttribute('id')}]`);

          if (drawer) {
              drawer.click();
          }
    
      }
    
}
customElements.define("map-holder", MapHolder);

class Tarot extends HTMLElement {   
    constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.cards = this.element.querySelector('.tarot-starsCardsWrapper');

    this.descriptions = this.element.querySelectorAll('.tarotDescription-cardWrapper');
    
    this.pickAnotherCards = this.element.querySelectorAll('.tarotDescription-pickAnother');
    
    this.bindEvents();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            "[data-action='pick-random-card']",
            this.toggleTarot.bind(this)
        );

        this.delegateElement.on(
            "click",
            "[data-action='pick-another-card']",
            this.pickAnotherCard.bind(this)
        );
    }

    toggleTarot() {
        var randomnumber = Math.floor(Math.random() * this.descriptions.length);
        this.description = this.descriptions[randomnumber];
        this.cards.classList.add('tarot-hidden');
        this.description.classList.remove('tarot-hidden');
        
    }

    pickAnotherCard() {
        this.cards.classList.remove('tarot-hidden');
        this.description.classList.add('tarot-hidden');
    }


}
customElements.define("tarot-cards", Tarot);


class BundleSelects extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.type = this.element.getAttribute('data-type');
        var selectboxes = this.element.querySelectorAll('select, input');
        selectboxes.forEach((item, _i) => {
            item.addEventListener("change", this.onVariantChange.bind(this));
        });
        this.productID = this.element.getAttribute('data-product-id');

    }

    onVariantChange() {

        this.updateOptions();
        this.updateMasterId();
      


        this.updateVariantInput();

    }


    updateOptions() {
        this.options = Array.from(
            this.querySelectorAll("select, input:checked"),
            (select) => select.value
        );
     
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            this.options
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });

    }

    updateVariantInput() {

        document.body.querySelector(`[data-find="${this.productID}"]`)
        .setAttribute('name', `${this.currentVariant.id}_id`);
        document.body.querySelector(`[data-find="${this.productID}"]`)
        .setAttribute('data-id', `${this.currentVariant.id}`);
    }

    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}
customElements.define("bundle-selects", BundleSelects);



class AtcHandler extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        new AddToCart(this.element);
    }

}
customElements.define("atc-handler", AtcHandler);

class CarouselReview extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.sidebarDrawer = new Drawer(this.element);
        // this.carousel = new RevolutionSwiper(this.carouselElement);
        this.reviewsHandler();

    }

    reviewsHandler(){
        var _this = this;
        var observer = new MutationObserver(function(_mutations) {
           if (_this.element.querySelector('.spr-button')) {
               _this.element.querySelector('.spr-summary-actions').style.display = "none";

             if(_this.element.querySelector('.ReviewFooter')){
               const node = _this.element.querySelector('.reviewStatus');
  
  
    node.appendChild(_this.element.querySelector('#productReview').content.firstElementChild.cloneNode(true));
    const number = parseFloat(_this.element.querySelector('#productReview').content.firstElementChild.getAttribute('data-value'));
  
                node.querySelector('value').innerHTML = number.toFixed(2);
                node.appendChild(_this.element.querySelector('.spr-summary-starrating'));
                _this.element.getAttribute('data-pid');
  
             }
            //  _this.element.querySelector('.reviewsContentEnter').appendChild(_this.element.querySelector('.spr-form'));
             _this.element.querySelector('.spr-form').style.display = "block";
  
  
                observer.disconnect();
  
  
  
            }
        });
  
        observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
  
  
  
      }

}
customElements.define("carousel-review", CarouselReview);


class InspirationDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.element = this),
      (this.sidebarDrawer = new Drawer(this.element));
  }
}
customElements.define("inspiration-drawer", InspirationDrawer);

class MapSearch extends HTMLElement{
    constructor(){
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);


      this.bindEvents();
      }
      bindEvents() {
        this.delegateElement.on('keyup', '[data-action="searchItem"]', this.search.bind(this));

    }

    search() {

        let input = document.getElementById('searchBar').value;
        input = input.toLowerCase();
        var dropdown =   document.body.querySelector('#countriesDropdown .RevolutionDropdown--Button');
        if (dropdown.getAttribute('aria-expanded') == "false"){
            dropdown.click();
        }

        var searchableItems = document.body.querySelectorAll('#countriesDropdown .RevolutionDropdown--Item');
        var i = 0;

        for (i = 0; i < searchableItems.length; i++) {
            if (!searchableItems[i].innerHTML.toLowerCase().includes(input)) {
                searchableItems[i].style.display = "none";
            } else {
                searchableItems[i].style.display = "block";
            }
        }
    }

}
customElements.define("map-search", MapSearch);

class ContactSelectbox extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        var selectBoxes = this.element.querySelector(".RevolutionDropdown");
        this.select = new RevolutionSelectbox(selectBoxes);
    }
    }
    customElements.define("contact-dropdown", ContactSelectbox);


    


    class cartUpsell extends HTMLElement {
        constructor() {
        super();
        this.element = this;
        this.delegateBody = new Delegate(document.body);
        this.pageOverlayElement = this.element.querySelector('.pageOverlayOver');
        this.delegateElement = new Delegate(this.element);
        this.optionsKit = JSON.parse(
            this.element.getAttribute("data-kit")
        );
        this.cartItems = this.element.getAttribute('data-carthandles');
        this.cartItems = this.cartItems.split(',')

        if(this.optionsKit){
            this.kithandler();
        }
       this.getItems();

          if (document.body.getAttribute('upsell-created') != true){
               this.bindEvents();
          }
    
    }
    
    bindEvents(){
        this.delegateElement.on(
            "click",
            '[data-action="remove-item"]',
            this.updateItemQuantity.bind(this)
        );
        this.delegateBody.on(
            "click",
            '[data-action="open-upsell"]',
            this.openModal.bind(this)
        );

        this.delegateBody.on(
            "click",
            '[data-action="upgrade-cart"]',
            this.upgaredCart.bind(this)
        );
    
        this.delegateElement.on("click", '[data-action="close-modal"]', this.closeModal.bind(this));
        this.changeListener = this.kithandler.bind(this);
        document.addEventListener("product:added", this.changeListener);
        document.addEventListener("cart:refresh", this.changeListener);
        document.body.setAttribute('upsell-created',true);
    }



    
    kithandler(){
      let intersectItems = [],
            mainKey = 0;
        this.optionsKit = JSON.parse(
            this.element.getAttribute("data-kit")
        );
        this.cartItems = this.element.getAttribute('data-carthandles');
        this.cartItems = this.cartItems.split(',')
    
        const keys = Object.keys(this.optionsKit);
      

            keys.forEach((key, _index) => {
                const bundleArray = this.optionsKit[key]['items'].split(',');
                if(intersectItems.length < 2){
                    intersectItems = bundleArray.filter(element => this.cartItems.includes(element));
                    mainKey = key;
                }
  
            
          
            });
            if(intersectItems.length >= 2){
                this.getItemsKits(this.optionsKit[mainKey]['main_item'], intersectItems);
            } else {
                this.getItems();
            }


    }

    getItemsKits(mainItem, products){
        let urlStrings = [];
        const _this = this;

    

        products.forEach((product) => {
            urlStrings.push(
                fetch(`${window.routes.localeRootUrl}/products/${product}.js`, {
                    credentials: "same-origin",
                    method: "GET",
                  }))
        });

        urlStrings.push(
            fetch(`${window.routes.localeRootUrl}/products/${mainItem}.js`, {
                credentials: "same-origin",
                method: "GET",
              }))

        Promise.all(urlStrings).then(function (responses) {
            Promise.all(
                responses.map(function (response) {
                return response.json();
                })).then(function (contents) {
                if (contents.length > 0 && sessionStorage.getItem('popupUpsell') != 'true'){
                    var checkoutButton = document.querySelector('.cartCheckout--Button');
                    checkoutButton.removeAttribute('type');
                    checkoutButton.setAttribute('data-action','open-upsell');
                    checkoutButton.setAttribute('aria-controls','upsellPopup');
                 //checkoutButton.removeAttribute('disabled');
                    _this.generateKits(contents,products);
                } else {
                    var checkoutButton = document.querySelector('.cartCheckout--Button');
                    checkoutButton.removeAttribute('data-action');
                    checkoutButton.removeAttribute('aria-controls');
                    checkoutButton.setAttribute('type','submit');
                }
                
                })
        })

    }


    upgaredCart(event){
        event.preventDefault();
        const itemsToRemove = event.target.closest('.upsellContentUpsell').previousElementSibling.dataset.handles;
        const _this = this;
        const keyToAdd = event.target.dataset.id;
       const itemsToRemoveArray = itemsToRemove.split(',');
       let formData = {
        'updates': {}
    };
        const cartData = document.querySelector('#cartData');

        itemsToRemoveArray.forEach((item) => {
            const keyToRemove = cartData.querySelector(`[data-handle='${item}']`).querySelector('.QuantitySelector__CurrentQuantity').getAttribute('data-line-id');
            formData['updates'][keyToRemove] = 0;
       
        });
   
        fetch(window.routes.localeRootUrl + "/cart/update.js", {
            body:JSON.stringify(formData),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          }).then(function (_content) {
   
            setTimeout(() => {
                fetch(window.routes.localeRootUrl + "/cart/add.js", {
                  body: JSON.stringify({
                    items: [{
                      id: keyToAdd,
                      quantity: 1
                    }]
                  }),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                }).then(function (_content) {
                  if (window.location.href.indexOf("/cart") > -1) {
                    location.reload();
                } else {
                    _this.element.dispatchEvent(
                        new CustomEvent("product:added", {
                            bubbles: true
                        })
                    );
                }
                 
                });
              }, 500);


        });
  
    }
    
    getItems(){
        this.options = JSON.parse(
            this.element.getAttribute("data-settings")
        );

        this.pairs = this.element.dataset.pairs;
        const productsLimit = parseInt(this.element.dataset.productsLimit) //e.g. 3
        
        let index = 0;
        this.mainItems = [];
        let urlStrings = [];
        let products = [];
        let _this = this;
        const keys = Object.keys(this.options);
        keys.forEach((key) => {
            this.mainItems.push(index);
            urlStrings.push(
                fetch(`${window.routes.localeRootUrl}/products/${key}.js`, {
                    credentials: "same-origin",
                    method: "GET",
                  }))
                  index++;


        let obj = Object.fromEntries(Object.entries(this.options[key].items).slice(0,productsLimit)); // this will show only 3 product in object
   
        products.push('false');
           for (const ke in obj) {
                urlStrings.push(
                    fetch(`${window.routes.localeRootUrl}/products/${obj[ke].handle}.js`, {
                        credentials: "same-origin",
                        method: "GET",
                      }))
                      products.push(obj[ke].is_in_cart);
                      index++;
                
            }
     });

      
    
        Promise.all(urlStrings).then(function (responses) {
            Promise.all(
                responses.map(function (response) {
                return response.json();
                })).then(function (contents) {
                 
                if (contents.length > 0 && sessionStorage.getItem('popupUpsell') != 'true'){
                    var checkoutButton = document.querySelector('.cartCheckout--Button');
                    checkoutButton.removeAttribute('type');
                    checkoutButton.setAttribute('data-action','open-upsell');
                    checkoutButton.setAttribute('aria-controls','upsellPopup');
                 checkoutButton.removeAttribute('disabled');
                    _this.generateProducts(contents,products);
                } else {
                    var checkoutButton = document.querySelector('.cartCheckout--Button');
                    checkoutButton.removeAttribute('data-action');
                    checkoutButton.removeAttribute('aria-controls');
                    checkoutButton.setAttribute('type','submit');
                }
                
                })
        })
    }

    
    
    updateItemQuantity(event, target) {
        event.preventDefault();
          var _this = this;
          this.upsellRemove = this.element.querySelector('.upsellButtonRemove');
          if(this.upsellRemove){
            this.upsellRemove.setAttribute('disabled','true');
        }


          var quantity = parseInt(target.getAttribute("data-quantity"));
          
    
          fetch(window.routes.localeRootUrl + "/cart/change.js", {
              body: JSON.stringify({
                  id: target.getAttribute("data-line-id"),
                  quantity: quantity,
              }),
              credentials: "same-origin",
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
              },
          }).then(function (_content) {
            _this.element.dispatchEvent(
                new CustomEvent("product:added", {
                    bubbles: true
                })
            );
          });
    
    
      }


    generateKits(content, products){
        const _this = this;
        const stringProducts = products.toString();
        this.mainArea = this.element.querySelector('.upsellContentArea');
            this.mainArea.innerHTML = "";
            let el = document.createElement('div');
            el.classList.add('upsellContentMain');
            el.classList.add('upsellContentKits');
            el.setAttribute('data-handles',stringProducts);
            this.mainArea.append(el);
            this.upsellArea = document.createElement('div');
            this.upsellArea.classList.add('upsellContentUpsell');
            this.upsellArea.innerHTML = '<div class="upsellContentVerticalLine"></div>';
            this.mainArea.append(this.upsellArea);
        console.log(content);

        content.forEach((item, index) => {

            if (index == content.length - 1) {
                const generated = document.createElement('div');
                generated.classList.add('upsellitem');
                generated.innerHTML = this.productTemplate(item);
                console.log('generate');
                let upsellArea = this.element.querySelector('.upsellContentUpsell:last-child');
                upsellArea.append(generated);
                
                const button = document.createElement('button');
                button.classList.add('upsellButton');
                button.classList.add('u-pb2');
                button.classList.add('mt-s');
                button.setAttribute('data-action','upgrade-cart');
                button.classList.add('upsellButtonAdd');
                button.setAttribute('data-id', item.variants[0].id); 
                
                const el = upsellArea.querySelector(`#uppsellProduct__${item.id}`);
                button.innerHTML = `<svg width="20" style='margin-right: 12px' height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_6196_8338)">
                <path d="M10.8333 16.2171V6.90875L14.9 10.9754C15.225 11.3004 15.7583 11.3004 16.0833 10.9754C16.4083 10.6504 16.4083 10.1254 16.0833 9.80042L10.5917 4.30875C10.2667 3.98375 9.74166 3.98375 9.41666 4.30875L3.91666 9.79209C3.59166 10.1171 3.59166 10.6421 3.91666 10.9671C4.24166 11.2921 4.76666 11.2921 5.09166 10.9671L9.16666 6.90875V16.2171C9.16666 16.6754 9.54166 17.0504 10 17.0504C10.4583 17.0504 10.8333 16.6754 10.8333 16.2171Z" fill="black"/>
                </g>
                <defs>
                <clipPath id="clip0_6196_8338">
                <rect width="20" height="20" fill="white" transform="translate(0 0.383728)"/>
                </clipPath>
                </defs>
                </svg>                
                Uppgradera`;
                console.log(generated);
                if (!el) return;
                el.append(button);
               
            } else {
                console.log('generate2', el);
                const generated = document.createElement('div');
                generated.classList.add('upsellitem');
                generated.innerHTML = this.productTemplate(item);
                console.log(generated);
                el.append(generated);
            
            }
    
       
        });
   
        this.mainArea.append(this.upsellArea);

        setTimeout(() => {
            this.setLineHeight(content.length);
            new AddToCart(this.element);
          }, 400)
    
    }


    generateProducts(content,products){
        const _this = this;

        this.mainArea = this.element.querySelector('.upsellContentArea');
            this.mainArea.innerHTML = "";
        content.forEach((item, index) => {
            
            this.upsellArea = document.createElement('div');
            this.upsellArea.classList.add('upsellContentUpsell');
            this.upsellArea.innerHTML = '<div class="upsellContentVerticalLine"></div>';

            const generated = document.createElement('div');
            generated.classList.add('upsellitem');
            generated.innerHTML = this.productTemplate(item);

            if (this.mainItems.includes(index)){
          
                let el = document.createElement('div');
                el.classList.add('upsellContentMain');
                el.append(generated);
                this.mainArea.append(el);
                this.mainArea.append(this.upsellArea);
                
            } else {
                    let upsellArea = this.element.querySelector('.upsellContentUpsell:last-child');
                    upsellArea.append(generated);
                if (products[index] == "true" && !this.mainItems.includes(index)){
                    const button = document.createElement('button');
                    button.classList.add('upsellButton');
                    button.classList.add('upsellButtonRemove');
                    button.classList.add('u-pb2');
                    button.classList.add('mt-s');
                    button.setAttribute('data-action','remove-item');
                    button.setAttribute('data-quantity','0');
              
                    const cartItem = document.querySelector(`[data-${item.id}]`);
               
                    if (cartItem){
                    const lineKey = cartItem.querySelector('.QuantitySelector__CurrentQuantity').getAttribute('data-line-id');
                    button.setAttribute('data-line-id',lineKey);
                    }
               
                    const el = this.element.querySelectorAll(`#uppsellProduct__${item.id}`);
                    
                    button.innerHTML = `Ta bort`;
                 if (!el) return;
                    el.forEach((item) => {
                        item.append(button);
                    });
       
                }else{
                    const button = document.createElement('button');
                    button.classList.add('upsellButton');
                    button.classList.add('u-pb2');
                    button.classList.add('mt-s');
                    button.setAttribute('data-action','add-to-cart');
                    button.classList.add('upsellButtonAdd');
                
                    const el = upsellArea.querySelector(`#uppsellProduct__${item.id}`);
                    button.innerHTML = `<svg width="16" height="16" class="mr-m" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_6095_7356)">
                    <path d="M12 8.66667H8.66671V12C8.66671 12.3667 8.36671 12.6667 8.00004 12.6667C7.63337 12.6667 7.33337 12.3667 7.33337 12V8.66667H4.00004C3.63337 8.66667 3.33337 8.36667 3.33337 8C3.33337 7.63333 3.63337 7.33333 4.00004 7.33333H7.33337V4C7.33337 3.63333 7.63337 3.33333 8.00004 3.33333C8.36671 3.33333 8.66671 3.63333 8.66671 4V7.33333H12C12.3667 7.33333 12.6667 7.63333 12.6667 8C12.6667 8.36667 12.3667 8.66667 12 8.66667Z" fill="black"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_6095_7356">
                    <rect width="16" height="16" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg>
                    Lägg till`;
       
                    if (!el) return;
                    el.append(button);
                }
            }
    
       
        });
        setTimeout(() => {
            this.setLineHeight(content.length);
            new AddToCart(this.element);
          }, 400)
    
    }
    
    setLineHeight(length){
        const allItems = this.element.querySelectorAll('.upsellitem');
        const last = allItems[allItems.length- 1];
        let lastHeightActions = 0;

        const lastHeightActionsEl = last.querySelector('.upsellProductActions');
        if(lastHeightActionsEl){
               lastHeightActions = lastHeightActionsEl.offsetHeight;
        }
    
        const lastHeightImg = last.querySelector('.upsellProductImage').offsetHeight;
    

        const difference = 80 - lastHeightActions;

        document.documentElement.style.setProperty(
            "--line-adjust",
            `${difference + length * 2}px`
        );
    
    }
    
    productTemplate(item){
        let template = "";
        const price =  Shopify.formatMoney(
            item.price,
            window.theme.moneyFormat);
        const comparePrice =  Shopify.formatMoney(
            item.compare_at_price,
            window.theme.moneyFormat);
        if (comparePrice > 0 ){
             template = `<div class="upsellProductWrapper mb-l" data-handle="${item.handle}">
            <div class="upsellProductWrapper">
            <div class="upsellLine"><svg width="20" height="8" viewBox="0 0 20 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6991 0.159096L19.8548 3.61591C20.0484 3.82804 20.0484 4.17196 19.8548 4.38409L16.6991 7.8409C16.5054 8.05303 16.1915 8.05303 15.9978 7.8409C15.8042 7.62878 15.8042 7.28485 15.9978 7.07272L18.307 4.54319L0 4.54319L0 3.45681L18.307 3.45681L15.9978 0.927276C15.8042 0.715149 15.8042 0.371223 15.9978 0.159096C16.1915 -0.0530318 16.5054 -0.0530318 16.6991 0.159096Z" fill="black"/>
            </svg>
            </div>
            <img class="lazyload upsellProductImage" data-src="${item.featured_image}" data-widths="[400,600]">
            </div>
            <div class="upsellProductActions">
            <div class="upsellProductData">
            <div class="upsellProductTitle u-h6 mb-s">
            ${item.title}
            </div>
            <div class="upsellProductPrices">
                <div class="upsellProductComparePrice u-p5">${comparePrice}</div>
                <div class="upsellproductPrice u-pb2 ml-m">${price}</div>
            </div>
            </div>
            <form id="uppsellProduct__${item.id}">
            <input type="hidden" name="quantity" value="1" >
            <input type="hidden" name="id" data-productid="${item.id}" value="${item.variants[0].id}">
            </form>
            </div>
        
        
        </div>`;
        } else {
            template = `<div class="upsellProductWrapper mb-l" data-handle="${item.handle}">
            <div class="upsellProductWrapper">
            <div class="upsellLine"><svg width="20" height="8" viewBox="0 0 20 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6991 0.159096L19.8548 3.61591C20.0484 3.82804 20.0484 4.17196 19.8548 4.38409L16.6991 7.8409C16.5054 8.05303 16.1915 8.05303 15.9978 7.8409C15.8042 7.62878 15.8042 7.28485 15.9978 7.07272L18.307 4.54319L0 4.54319L0 3.45681L18.307 3.45681L15.9978 0.927276C15.8042 0.715149 15.8042 0.371223 15.9978 0.159096C16.1915 -0.0530318 16.5054 -0.0530318 16.6991 0.159096Z" fill="black"/>
            </svg>
            </div>
            <img class="lazyload upsellProductImage" data-src="${item.featured_image}" data-widths="[400,600]">
            </div>
            <div class="upsellProductActions">
            <div class="upsellProductData">
            <div class="upsellProductTitle u-h6 mb-s">
            ${item.title}
            </div>
            <div class="upsellProductPrices">
                <div class="upsellproductPrice u-pb2">${price}</div>
            </div>  </div>
            <form id="uppsellProduct__${item.id}">
            <input type="hidden" name="quantity" value="1" >
            <input type="hidden" name="id" data-productid="${item.id}" value="${item.variants[0].id}">
            </form>
            </div>
        </div>`;
        }
    
        return template;
    }
    
    openModal() {
        event.preventDefault();
        event.stopPropagation();
        this.pageOverlayElement.classList.add("is-visible");
        this.activeModal = document.getElementById('upsellPopup');
        this.activeModal.setAttribute("aria-hidden", "false");
        this.activeModal.style.display = "flex";
        this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);
    
        setTimeout(() => { trapFocus(this.activeModal); }, 100);
        Utility.bodyScrollLockDisable(this.element);
    }
    
    closeModal() {
    
        this.activeModal = document.body.querySelector('.Popup[aria-hidden="false"]');
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);
        this.activeModal.setAttribute("aria-hidden", "true");
    
        Utility.bodyScrollLockClear();
        this.activeModal.removeAttribute("style");
        sessionStorage.setItem('popupUpsell','true');
      var checkoutButton = document.querySelector('.cartCheckout--Button');
                    checkoutButton.removeAttribute('data-action');
                    checkoutButton.removeAttribute('aria-controls');
                    checkoutButton.setAttribute('type','submit');
    
    }
    
    
    }
    customElements.define("cart-upsell", cartUpsell);

class progressBar extends HTMLElement {
constructor() {
    super();
    this.element = this;
    let total = parseInt(this.element.querySelector('.progress-bar-outer').getAttribute('data-price'));
    let amount = parseInt(this.element.querySelector('.data-amount').getAttribute('data-amount'));

    if(total > amount){
        var freeDelivery = this.element.querySelector('.progress-bar-inner');
        freeDelivery.style.width = '100%';
      }
      else{
        let per = (total / amount) * 100;
        const am = Math.round(amount - (total  / 100));

        var freeDelivery = this.element.querySelector('.progress-bar-inner');
        freeDelivery.style.width = `${per}%`

        /*var span1 = this.element.querySelector('.span1');
        var span2 = this.element.querySelector('.span2');
        var span3 = this.element.querySelector('.span3');
        var span4 = this.element.querySelector('.data-amount');
        
       var more = amount - total;
   
        span1.innerHTML = 'Lägg till '
        span2.innerHTML = 'för '
        span3.innerHTML = 'fri frakt!'
        span4.innerHTML = more + ' kr'*/
    }
}
}
customElements.define("progress-bar", progressBar);


class upsellInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.bindEvents();
  }

  bindEvents(){
    this.delegateElement.on(
        "click",
        '[data-action="add-upsell"]',
        this.toggleAddButton.bind(this)
    );
  
}

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
          addButtonInner = addButton.querySelector(".SelfAlign"),
          quantityEl = document.querySelectorAll('.upsellButton');
          const item = event.target;
        
          if (item.checked == true) {
            var itemQuantity = item.getAttribute('value');
       
          }

    if (!addButton) return;

    if (!itemQuantity){itemQuantity = 1;}

      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
     
        var priceElement =
          "<span class='u-pb1 ml-s buttonInnerPrice'>" +
          Shopify.formatMoney(
            this.options['price'] * itemQuantity,
            window.theme.moneyFormat
          );
        +"</span>";
      
      addButtonInner.innerHTML =
        window.variantStrings.addToCart + ' for ' + priceElement;

  }

}
customElements.define("upsell-input", upsellInput);

class GwpBlock extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.mainWrapper = this.element.querySelector(".Gwp--Main");
      this.totalPrice = parseFloat(this.mainWrapper.getAttribute("data-total"));

      this.checkmarkSvg = 
        `<svg class="Gwp--Checkmark" width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.82415 6.15237L0.726419 4.05464L0.012085 4.76395L2.82415 7.57601L8.86078 1.53938L8.15147 0.830078L2.82415 6.15237Z" fill="white"></path>
        </svg>`;

      const atLeastOneBlock = this.element.querySelector(".Gwp--Block");

      if (atLeastOneBlock) {
        this.getCart();
        this.checkConditions();
      } else {
        this.element.style.display = "none";
      }
    }

    refreshGwp() {
        const tempGwp = document.querySelector("gwp-block");
        tempGwp.innerHTML = this.element.innerHTML;
        this.element = tempGwp;
    }

    checkConditions(){
        const blocks = Array.from(this.element.querySelectorAll(".Gwp--Block"));
        const sessionObjectList = [];

        for (let i = 0; i < blocks.length; i++) {
            let price = parseFloat(blocks[i].getAttribute("data-condition"));
            const productId = blocks[i].getAttribute("data-product-id");

            sessionObjectList.push({conditionPrice: price, productId: productId});

            price = Math.round(price * Shopify.currency.rate);

            const ratio = this.totalPrice / price;

            if (ratio <= 1) {
                const heading = blocks[i].getAttribute("data-condition-label");
                const index = i + 1;

                this.updateLoadBar(index, ratio, blocks.length);
                this.updateHeading(heading, price);
                break;
            } else {
                if (blocks.length - 1 === i) {
                    const heading = blocks[i].getAttribute("data-condition-meet-text");

                    this.updateLoadBar(1, 1, 1);
                    this.updateHeading(heading, 0);
                }

                blocks[i].setAttribute("data-check", "true");
                this.showFreeGift(blocks[i]);
                this.updateIcon(blocks[i]);
            }
        }

        sessionStorage.setItem("Gwp", JSON.stringify(sessionObjectList));
        this.refreshGwp();
    }

    showFreeGift(block) {
        const template = block.querySelector("template"); 

        if (template) {
            const elem = document.createElement("div");
            elem.innerHTML = template.innerHTML;

            const container = this.element.querySelector(".Gwp--FreeProducts");
            container.style.display = "flex";
            container.appendChild(elem);
        }
    }

    async getCart() {
        try {
            const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
            });
          
            const data = await response.json();
            this.cart = data;

            this.loadData();
        } catch (error) {
            console.log('Fetch Error:', error);
        }
    }

    loadData() {
        /* remove gifts from cart */
        const cartItems = this.cart.items;
        let removeGifts = false;
        let keys = {
            'updates':{}
        };

        cartItems.forEach(item => {
            if (item.product_type === "Gift") {
                const id = item.variant_id;
                const gwpBlock = this.element.querySelector(`.Gwp--ProductBlock[data-check="true"][data-product-id="${id}"]`)

                if (!gwpBlock) {
                    keys['updates'][`${item.key.toString()}`] = 0;
                    removeGifts = true;
                } else {
                    gwpBlock.removeAttribute("data-check");
                }

                if (item.quantity > 1) {
                    keys['updates'][`${item.key.toString()}`] = 1;
                    removeGifts = true;
                }
            }
        });

        if (removeGifts) {
            this.removeGiftsFromCart(keys);
        }

        /* add gifts to cart */
        const items = [];

        const achievedConditions = Array.from(this.element.querySelectorAll('.Gwp--ProductBlock[data-check="true"]'));
        achievedConditions.forEach(block => {
            const id = block.getAttribute("data-product-id");
            items.push({id: id, quantity: 1,});
        });

        if (items.length > 0) {
            this.addGiftsToCart(items);
        }
    }


    async addGiftsToCart(items) {
        if (items.length > 0) {
            try {
                const response = await fetch(window.routes.localeRootUrl + "/cart/add.js", {
                  body: JSON.stringify({
                    items: items
                  }),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                });

                if (response.ok) {
                    console.log("Gift added");
                } else {
                    console.log("Gift adding failed");
                }
              
              } catch (error) {
                console.error("Failed to add gift", error);
              }
        }
    }

    async removeGiftsFromCart(keys) {
        console.log("Removed", keys);
        if (keys) {
            try {
              await fetch(window.routes.localeRootUrl + "/cart/update.js", {
                body: JSON.stringify(
                    keys,
                ),
                credentials: "same-origin",
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
              });
      
            } catch(error) {
              console.error("One of the gifts does not exist in cart or", error);
            }
        }
    }

    updateHeading(heading, price) {
        const difference = price - this.totalPrice;
        const headingDiv = this.element.querySelector(".Gwp--Heading");

        headingDiv.innerText = heading.replace("{{ price }}", difference + " " + Shopify.currency.active)
    }

    updateLoadBar(index, ratio, length) {
        const progress = Math.round((100 / length) * parseInt(index)) * ratio;
        this.element.querySelector(".Gwp--LoadingBarInner").style.width = progress + "%";
    }

    updateIcon(block) {
        const iconContainer = block.querySelector(".Gwp--Icon");

        if (iconContainer) {
            iconContainer.innerHTML = this.checkmarkSvg;
        }
    }
  }
  
  customElements.define("gwp-block", GwpBlock);

class GTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);
        this.bindEvents();
        this.observeDOMChanges();
        this.handleIntersects();
    }

    bindEvents() {
        this.handleCheckoutListener = this.handleCheckout.bind(this);
        document.addEventListener("checkout:init", this.handleCheckoutListener);

        this.delegateBody.on("click", '[data-action="ga-send-select"]', this.handleSelectItem.bind(this));
        this.delegateBody.on("click", '[data-action="remove-item"]', this.removeFromCart.bind(this));
            }

    handleIntersects() {
        const allIntersections = document.body.querySelectorAll('[data-gtag-intersection]');

        allIntersections.forEach((item) => {
            if (item.dataset.observed !== 'true') {
                const observer = new IntersectionObserver(this.handleIntersection.bind(this), {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.1
                });

                observer.observe(item);
                item.dataset.observed = 'true';
            }
        });
    }

    observeDOMChanges() {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    this.handleIntersects();
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: false
        });
    }

    handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const data = JSON.parse(entry.target.querySelector('script[type="application/ld+json"]').textContent);

                if (!dataLayer || !data) return;
                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);
            }
        });
    }

    handleCheckout() {
        const target = document.querySelector('.cart--checkoutBtn');
        const settings = JSON.parse(target.dataset.settings);

        if (!dataLayer || !settings) return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push(settings);
    }

    handleSelectItem(event) {
        let target = event.target;
        if (event.target.classList.contains('Product-ATCButton') || event.target.closest('.Product-ATCButton')) return;
        if (event.target.dataset.action != 'ga-send-select') {
            target = event.target.closest('[data-action="ga-send-select"]');
        }

        const settings = JSON.parse(target.dataset.settings);

        if (!dataLayer || !settings) return;

        dataLayer.push({
            'event': 'select_item',
            'selected_item_list_id': settings.list_id,
            'selected_item_list_name': settings.list_name,
            'selected_items': [{
                'item_id': settings.item_id,
                'item_name': settings.item_name,
                'price': settings.price,
                'item_list_id': settings.list_id,
                'item_list_name': settings.list_name
            }]
        });
    }

    removeFromCart(event) {
        let target = event.target;
        if (event.target.dataset.action != 'remove-item') {
            target = event.target.closest('[data-action="remove-item"]');
        }

        const settings = JSON.parse(target.closest('[data-remove]').dataset.remove);

        if (!dataLayer || !settings) return;

        dataLayer.push({
            'event': 'remove_from_cart',
            'remove': {
                'value': settings.value,
                'items': [{
                    'item_id': settings.item_id,
                    'item_name': settings.item_name,
                    'price': settings.price,
                    'quantity': settings.quantity
                }]
            }
        });
    }

  
}

function getTrackingConsentCookie() {
    var cookiesArray = document.cookie.split(';');
    for (var i = 0; i < cookiesArray.length; i++) {
        var cookie = cookiesArray[i].trim();
        if (cookie.startsWith('_tracking_consent=')) {
            return cookie.substring('_tracking_consent='.length, cookie.length);
        }
    }
    return null;
}

let consent = false;
var trackingConsent = getTrackingConsentCookie();
var decodedString = decodeURIComponent(trackingConsent);
var jsonObject = JSON.parse(decodedString);
if (jsonObject && jsonObject.con.CMP.a == 1) {
    consent = true;
}

function addEventListenerForAcceptBtn(adittionalChecks = 0) {
    if (window.isenseGDPR !== undefined) {
        window.addEventListener('click', function (e) {
            const isAcceptButton = e.target && typeof e.target.className === 'string' && e.target.className.indexOf('isense-cc-submit-consent') >= 0 &&
                (e.target.className.indexOf('cc-btn-accept-all') >= 0 || e.target.className.indexOf('cc-allow') >= 0);

            if (isAcceptButton) {
                new GTagEvents();
            }
        });
    } else {
        if (adittionalChecks > 0) {
            setTimeout(function () {
                addEventListenerForAcceptBtn(adittionalChecks - 1);
            }, 500);
        }
    }
}

if (consent == true) {
    document.addEventListener("DOMContentLoaded", (_event) => {
        new GTagEvents();
    });
} else {
    addEventListenerForAcceptBtn(40);
}


/*document.addEventListener('DOMContentLoaded', () => {
    if (window.okeWidgetApi && window.okeWidgetApi.initAllWidgets) {
      window.okeWidgetApi.initAllWidgets();
    }
  });*/
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.element = this;

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        

        observer.unobserve(this);

        fetch(this.dataset.url).then(response => response.text()).then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            new AddToCart(this);
            new RevolutionSwiper(this.querySelector('.swiper'));

            this.widgetElement = this.element.querySelectorAll('[data-oke-star-rating]');
            this.widgetElement.forEach((item) => {
                window.okeWidgetApi.initWidget(item);
            });
      
            if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
              new RevolutionAnimation(this);
            }
          }

        }).catch(e => {
          console.error(e);
        });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '-100px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


class NewHeroBanner extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
    }

    connectedCallback() {        
        this.reviewsElement = this.element.querySelector('.new-hero-banner__helper-reviews [data-oke-carousel]');        
        if (!this.reviewsElement) return this.element.querySelector(".new-hero-banner__swiper").style.display = "none";

        const observer = new MutationObserver((entries) => {                        
            if (this.reviewsElement.querySelector(".oke-product-thumbnail-image")) {
                observer.disconnect();

                const spins = 20, duration = 500, i = 0;
                this.spin(spins, duration, i);
            }
        })

        observer.observe( this.reviewsElement, {
            childList: true, // Observe direct children
            subtree: true, // and all descendants
            attributes: false
        });
    }

    // checks if condition is fullfiled, if not sleeps and checks again later
    // i - is current step
    // spin - is maximum times it checks condition
    // function that determens if condition is fulfiled
    // duration - ms it sleeps before checking again
    spin(spins, duration, i) {
        i = i || 0;

        if (this.isSrcLoaded()) return this.initReviews();
        if (i >= spins) return;

        setTimeout(() => {
            this.spin(spins, duration, ++i);
        }, duration)
    }

    isSrcLoaded() {            
        const images = this.reviewsElement.querySelectorAll("new-hero-banner .oke-product-thumbnail-image");
        let isLoaded = images[0]?.src;
        if(!isLoaded) return false;

        images.forEach((image) => {            
            if(!image.src) isLoaded = false;
        })
        
        return isLoaded;
    }

    initReviews() {
        const slides = this.reviewsElement.querySelectorAll(".oke-reviewCard");
        const template = this.element.querySelector(".new-hero-banner__slide-template").innerHTML;
        const swiperWrapper = this.element.querySelector(".new-hero-banner__swiper-wrapper")

        if (slides.length < 1) return;

        slides.forEach(slide => {
            swiperWrapper.append(this.buildSlideFromReview(slide, template));
        })

        this.initSwiper();
    }

    buildSlideFromReview(slide, template) {
        const div = document.createElement("div");
        div.innerHTML = template;
        div.classList.add("new-hero-banner__reviews-slide");
        div.classList.add("swiper-slide");

        const slideImg = slide.querySelector(".oke-product-thumbnail-image");
        const src = slideImg.src;

        if (slideImg) {
            const divImg = div.querySelector(".new-hero-banner__image-box");
            const newImg = slideImg.cloneNode(true);
            newImg.src = src;
            divImg.append(newImg);
        }
        
        const slideName = slide.querySelector(".oke-w-reviewer-name");        
        if (slideName) {
            const divName = div.querySelector(".new-hero-banner-user");            
            divName.innerHTML = slideName.innerHTML;
        }

        const slideDesc = slide.querySelector(".oke-bodyText");
        if (slideDesc) {
            const divDesc = div.querySelector(".new-hero-banner-desc");
            divDesc.innerHTML = slideDesc.innerHTML;
        }

        const slideStars = slide.querySelector(".oke-reviewContent-stars");
        if (slideStars) {
            const divStars = div.querySelector(".new-hero-banner__stars");
            divStars.innerHTML = slideStars.innerHTML;
        }

        const SlideBtnMore = slide.querySelector(".oke-product-thumbnail");
        if (SlideBtnMore) {
            const divButton = div.querySelector(".new-hero-banne__btn-more");
            divButton.href = SlideBtnMore.href;
        }
       
        return div;
    }

    initSwiper() {
        const carouselElement = this.element.querySelector(".new-hero-banner__swiper");
        new RevolutionSwiper(carouselElement);
    }
}
  
  customElements.define("new-hero-banner", NewHeroBanner);